// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T23:03:27.695Z
// Property: Rye Bunker Hill (ID: 6767906449167585)
// Collections: 39 amenities, 14 floorplans (live), 99 photos, 77 POIs, 5 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167585",
  "property_external_id": "1677433",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/rye-bunker-hill-apartments-garland-tx/mvspffj/",
  "property_google_business_url": "https://www.google.com/maps/place/Rye+Bunker+Hill+Apartments/@32.9542529,-96.5915254,960m/data=!3m2!1e3!4b1!4m6!3m5!1s0x864c1d23be9ed2c3:0x7f2488f213d82aee!8m2!3d32.9542529!4d-96.5915254!16s%2Fg%2F11tdjknw1v?entry=ttu&g_ep=EgoyMDI2MDgxMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "39358347889",
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "pID: 1677433\npCode: p1645582",
  "property_status": null,
  "property_slug": "rye-bunker-hill",
  "property_name": "Rye Bunker Hill",
  "property_website_url": "https://www.ryebunkerhill.com/",
  "property_domain": "https://www.ryebunkerhill.com/",
  "property_address": "4401 Bunker Hill Rd",
  "property_full_address": "4401 Bunker Hill Rd, Garland, TX 75048",
  "property_address_1": "4401 Bunker Hill Rd",
  "property_address_2": null,
  "property_address_city": "Garland",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75048",
  "property_address_country": "US",
  "property_address_county": "Dallas County",
  "property_neighborhood_address": "Garland",
  "property_address_latitude": "32.9645994",
  "property_address_longitude": "-96.6018878",
  "property_email": "ryebunkerhillmanager@pricebrotherskc.com",
  "property_phone": "(214) 617-2285",
  "property_call_tracking_phone": "214-617-2285",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern style, easy Garland access.</strong> Explore fresh one-, two-, and three-bedroom <a href=\"/floor-plans\">apartments</a> with polished finishes, connected convenience, and resort-style spaces to recharge—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Rye Bunker Hill in person.</p>",
  "property_long_description": "<p><strong>Modern style, easy Garland access.</strong> Rye Bunker Hill brings fresh one-, two-, and three-bedroom <a href=\"/floor-plans\">apartments in Garland</a> to a connected spot near State Highway 78 and President George Bush Turnpike, placing Firewheel Town Center, Sachse, neighborhood dining, shopping, and everyday errands within an easy drive.</p><p>Inside, choose polished finishes like chef-inspired kitchens, quartz countertops, island layouts, walk-in closets, in-home washer/dryer convenience, and private balconies or patios in select homes. Beyond your door, <a href=\"/amenities\">resort-style amenities</a> add room to recharge: a saltwater pool with sun shelves, poolside cabanas, grilling lounges, fitness center, golf simulator, pickleball courts, clubhouse, business center, dog park, and pet spa. With lake access, a lake pavilion, and connections to Garland’s trail network nearby—plus Rowlett Creek Preserve and Downtown Garland’s DART Blue Line station within reach—you get a home that feels calm, current, and well placed for exploring the northeast Dallas area.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a0346d-5364-7724-a552-c2adebe06f5a.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and seating areas.",
    "public_id": "01a0346d-5364-7724-a552-c2adebe06f5a",
    "storage_key": "property/6767906449167585/01a0346d-5364-7724-a552-c2adebe06f5a.webp",
    "width": 1800,
    "height": 1060
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "356",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "86.51685393258427",
  "property_admin_fee": "200",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "500",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum 2 pets allowed. Breed restrictions apply.",
  "property_pet_policy_description": "We welcome dogs and cats. Maximum 2 pets allowed. Monthly pet rent: $25 per pet. Deposit: $300 for one pet, $500 total for two pets. Pet deposits are non‑refundable. Breed restrictions apply.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://ryebunkerhill.securecafeapplicant.com/onlineleasing/content3/access/the-rye-at-bunker-hill/floorplans",
  "property_resident_portal_url": "https://ryebunkerhill.securecafe.com/residentservices/the-rye-at-bunker-hill/userlogin.aspx",
  "property_apply_now_url": "https://ryebunkerhill.securecafeapplicant.com/onlineleasing/content3/access/the-rye-at-bunker-hill/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff690-4c08-71e9-9100-accddb0c46e6.webp",
  "property_primary_logo_media": {
    "alt_text": "Rye Bunker Hill logo",
    "public_id": "019ff690-4c08-71e9-9100-accddb0c46e6",
    "storage_key": "property/6767906449167585/019ff690-4c08-71e9-9100-accddb0c46e6.webp",
    "width": 1205,
    "height": 691
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff690-b780-77fc-99cb-9dbc19a43455.webp",
  "property_secondary_logo_media": {
    "alt_text": "RYE logo",
    "public_id": "019ff690-b780-77fc-99cb-9dbc19a43455",
    "storage_key": "property/6767906449167585/019ff690-b780-77fc-99cb-9dbc19a43455.webp",
    "width": 1205,
    "height": 691
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a0b05f-42d9-72b6-915d-1ed928a036af.webp",
  "property_fav_icon_media": {
    "alt_text": "Rye Bunker Hill logo",
    "public_id": "01a0b05f-42d9-72b6-915d-1ed928a036af",
    "storage_key": "property/6767906449167585/01a0b05f-42d9-72b6-915d-1ed928a036af.webp",
    "width": 256,
    "height": 256
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff691-7e51-72cb-8c42-3c6c0302556e.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019ff691-7e51-72cb-8c42-3c6c0302556e",
    "storage_key": "property/6767906449167585/019ff691-7e51-72cb-8c42-3c6c0302556e.webp",
    "width": 1205,
    "height": 691
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff691-7269-701f-b459-a737cdf14c1a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019ff691-7269-701f-b459-a737cdf14c1a",
    "storage_key": "property/6767906449167585/019ff691-7269-701f-b459-a737cdf14c1a.webp",
    "width": 1205,
    "height": 691
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#694F40",
  "property_secondary_color": "#B29574",
  "property_font_color": "#222222",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "578 - 1436",
  "property_sqft_min": "578",
  "property_sqft_max": "1436",
  "property_price_range": "1310 - 2549",
  "property_price_min": "1310",
  "property_price_max": "2549",
  "property_available_units": 48,
  "property_facebook_url": "https://www.facebook.com/ryebunkerhill/",
  "property_instagram_url": "https://www.instagram.com/ryebunkerhillapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJw9KeviMdTIYR7irYE_KIJH8",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rye Bunker Hill",
  "property_home_romance_title": "Embrace Life and Love at Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Resort-style amenities, polished daily convenience.</strong> At Rye Bunker Hill, your day can move from coffee and Wi-Fi in the clubhouse to a private work pod, fitness center session, or golf simulator. Outside, a saltwater pool with sun shelves, poolside cabanas, grilling lounges, pickleball courts, and a lake pavilion set the scene for easy downtime. Inside, quartz countertops, hardwood-style living areas, spa-inspired baths, walk-in closets, and select private balconies or patios keep the experience elevated.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Garland with polished finishes built into the everyday: chef-inspired kitchens, quartz countertops with backsplash, hardwood-style flooring, walk-in closets, in-home washer/dryer convenience, and select private balconies or patios. Find the layout that fits, then view current availability and pricing when you’re ready for the next step.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at Rye Bunker Hill.</strong> Preview bright kitchens with quartz surfaces, open living spaces with hardwood-style flooring, plush-carpeted bedrooms, and select balconies or patios. Then look beyond the front door to the clubhouse, golf simulator, saltwater pool, shaded cabanas, grilling areas, pickleball courts, and lake pavilion—just a glimpse of what you’ll find in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Open-air shopping, creekside trails, and lake-day energy.</strong> From Rye Bunker Hill, Garland makes it easy to shift gears: patio dining and AMC nights at Firewheel Town Center, soft-surface loops at Rowlett Creek Preserve, and live entertainment in Downtown Garland with Blue Line access nearby. Back home, outdoor amenities keep the relaxed rhythm going just outside your door.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to an easy, welcoming experience.</strong> Rye Bunker Hill residents highlight smooth leasing, quick move-ins, responsive maintenance, and clear communication from the office team.</p><p>Standout shoutouts go to Dakota, Walter, and Zach, along with clean, well-kept surroundings and amenities rated “10000/10.” One review says it simply: “I LOVE my view and my home is so peaceful.” Read more to see everyday life here through resident feedback.</p>",
  "property_neighborhood_blurb": "<p>Experience unparalleled living at Rye Bunker Hill, where community and convenience converge. Enjoy instant access to PGBT, bringing top-tier entertainment, prime shopping, and outdoor wonders within moments of your doorstep.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with more ways to spend your day.</strong> At Rye Bunker Hill, everyday convenience meets resort-level downtime: start with coffee and Wi-Fi in the clubhouse, focus in a private work pod, fit in a session at the fitness center, or practice your swing in the golf simulator. Outside, the saltwater pool with sun shelves, pool-side cabanas, grilling lounges, pickleball courts, and lake pavilion create an easy flow from relaxing to gathering.</p><p>Your apartment keeps the same polished rhythm with chef-inspired kitchens, quartz countertops, hardwood-style living areas, spa-inspired baths, in-home washer/dryer convenience, walk-in closets, and private balconies or patios in select layouts. Explore the <a href=\"/gallery\">amenity photos</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how it all comes together in Garland.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Rye Bunker Hill.</strong> Choose a fresh one-, two-, or three-bedroom apartment with polished finishes, in-home washer/dryer convenience, and easy Garland access. When you’re ready, apply online and take the next step toward a calm, current home near everyday essentials.</p>",
  "property_contactus_blurb": "<p>Our expert leasing professionals are ready to assist you in finding your new home. Rye Bunker Hill has so many options available. Let's get started!</p>",
  "property_faqs_blurb": "<p><strong>Questions about Rye Bunker Hill?</strong> Start here for quick answers on leasing, <a href=\"/floor-plans\">floor plans</a>, apartment features, community amenities, and daily living at our Garland apartments. If you don’t see what you need, the <a href=\"/contact-us\">leasing team</a> is happy to help.</p>",
  "property_floorplans_blurb": "<p>Experience the epitome of elegance with our spacious one, two, or three-bedroom apartment homes. Immerse yourself in open floor plans that effortlessly blend style and functionality. Our brand-new apartments showcase expansive living spaces and lavish closets adorned with bespoke wood shelving, providing ample storage solutions. Retreat to our generously sized bedrooms for a restful night's sleep, surrounded by unmatched comfort. Bask in the abundant natural light streaming through expansive windows, creating a serene ambiance to savor your morning rituals. Indulge in the convenience of modern amenities and the charm of Texan hospitality. At Rye Bunker Hill, every corner reflects our commitment to luxury and quality living.</p><p>Discover your perfect sanctuary today – schedule your appointment online or by calling (214) 390-6511&nbsp;and experience the pinnacle of upscale living firsthand!</p>",
  "property_gallery_blurb": "<p><strong>See Rye Bunker Hill from every angle.</strong> Browse the gallery for a closer look at the details that define this Garland apartment community: bright chef-inspired kitchens with quartz surfaces, open living areas with hardwood-style flooring, calm bedrooms with plush carpet, and private balconies or patios in select homes. As you move through the photos, notice how the indoor and outdoor spaces connect—from the clubhouse and golf simulator to the saltwater pool, shaded cabanas, grilling areas, pickleball courts, and lake pavilion. Use these images to picture the finishes, views, and shared spaces up close, then explore more <a href=\"/amenities\">amenities and apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience Rye Bunker Hill in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Rye Bunker Hill on the map.</strong> See available one-, two-, and three-bedroom apartments in a connected Garland location near major roadways, everyday shopping, dining, trails, and northeast Dallas-area destinations.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, rinses, and fresh-air routines.</strong> At Rye Bunker Hill, dogs and cats are part of everyday apartment life—not an afterthought. Let your dog stretch out at the spacious on-site dog park, clean up after muddy outings at the pet spa, then head back to a home designed for easy living with features like hardwood-style flooring in main areas, in-home washer/dryer convenience, and private balconies or patios in select layouts.</p><p>When you want more room to roam, direct access to Garland’s regional trail system adds a simple way to work walks into the day. Review the pet policy details below, explore more <a href=\"/amenities\">pet-friendly amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Rye Bunker Hill fits life with your four-legged companions.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Rye Bunker Hill lifestyle.</strong> If you love the modern finishes, easy Garland access, and resort-style spaces that make home feel fresh and connected, invite a friend to see it for themselves. Send a referral today and help them find their next <a href=\"/floor-plans\">one-, two-, or three-bedroom apartment</a> here.</p>",
  "property_residentaccess_blurb": "<p>With our convenient Resident Portal, we've made it super easy for you to pay your rent and submit service requests online. Just click, tell us what you need, and consider it done!</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real reasons to feel confident.</strong> As you read through Rye Bunker Hill reviews, you’ll see residents consistently highlight a smooth leasing experience, quick move-ins, and a team that makes each step simple to understand.</p><p>Residents also call out responsive service from the maintenance team, with praise for Dakota, Walter, and Zach, plus clear communication from the office. One resident summed it up best: “I LOVE my view and my home is so peaceful.” Others mention a clean, well-maintained community, welcoming interactions, and amenities they rate “10000/10.” Explore the reviews below to see what everyday living at Rye Bunker Hill is like from the people who know it firsthand.</p>",
  "property_created_at": "1785785496550",
  "property_scheduletour_blurb": "<p>Discover modern living in the heart of Garland. At Rye Bunker Hill, we offer thoughtfully designed apartments, elevated amenities, and a community atmosphere that makes you feel at home from day one.</p><p>Scheduling your tour is quick and easy—just choose the date and time that works best for you using the calendar below. Whether you prefer an in-person walkthrough or a live virtual tour, our team is here to guide you through everything Rye Bunker Hill has to offer.</p><p>Don’t wait—your next home could be just one tour away.</p><p>Experience Rye Bunker Hill with a personalized, one-on-one walk-through led by our knowledgeable onsite team members. Our Guided Tours give you the chance to explore amenities, tour model homes, ask questions in real time, and get a true feel for the lifestyle Rye Bunker Hill offers. It's the most interactive, relationship-driven way to experience living at Rye Bunker Hill.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Rye Bunker Hill’s leasing team will follow up soon. In the meantime, picture modern Garland apartments with polished finishes, in-home washer/dryer convenience, and resort-style spaces designed for easy everyday living in a connected northeast Dallas location.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Rye Bunker Hill",
  "property_seo_title_home": "Luxury Apartments in Garland, TX | Rye Bunker Hill",
  "property_seo_description_home": "Discover 1, 2 & 3 bedroom apartments in Garland, TX at Rye Bunker Hill with modern interiors, standout amenities and access to local trails.",
  "property_seo_title_floorplans": "1, 2 & 3 Bedroom Apartments in Garland, TX",
  "property_seo_description_floorplans": "Explore 1, 2 & 3 bedroom apartments in Garland at Rye Bunker Hill. Compare floor plans from 578 to 1,436 sq. ft. and check availability.",
  "property_seo_title_amenities": "Luxury Apartment Amenities in Garland, TX",
  "property_seo_description_amenities": "Explore Rye Bunker Hill amenities including a saltwater pool, pickleball courts, golf simulator, fitness center, work pods and more.",
  "property_seo_title_gallery": "Garland, TX Apartment Photos | Rye Bunker Hill",
  "property_seo_description_gallery": "Browse Rye Bunker Hill apartment photos and explore modern interiors, community spaces and outdoor amenities in Garland, TX.",
  "property_seo_title_virtualtours": "Virtual Tours | Rye Bunker Hill Apartments",
  "property_seo_description_virtualtours": "Experience Rye Bunker Hill in Garland, TX! Take a virtual tour of our one, two, and three-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Rye Bunker Hill Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Rye Bunker Hill in Garland, TX! Use our interactive map to explore stunning apartments, diverse floor plans, and premium amenities!",
  "property_seo_title_neighborhood": "Apartments Near Firewheel Town Center | Rye",
  "property_seo_description_neighborhood": "Explore apartments near Firewheel Town Center, parks, trails, shopping and dining at Rye Bunker Hill in Garland, TX.",
  "property_seo_title_contact": "Contact Rye Bunker Hill Apartments in Garland, TX",
  "property_seo_description_contact": "Contact Rye Bunker Hill at 4401 Bunker Hill Rd in Garland, TX for questions about availability, floor plans, amenities and leasing.",
  "property_seo_title_faqs": "FAQs | Apartments in Garland, TX",
  "property_seo_description_faqs": "Find answers to your questions about Rye Bunker Hill in Garland, TX. Learn about our spacious floor plans, amenities, and how to make our community your home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Garland, TX",
  "property_seo_description_reviews": "Discover life at Rye Bunker Hill in Garland, TX! Read real resident reviews and explore a vibrant community with amazing amenities and floor plans.",
  "property_seo_title_applynow": "Apply Now | Apartments in Garland, TX",
  "property_seo_description_applynow": "Elevate your lifestyle at Rye Bunker Hill, Garland, TX! Choose from spacious 1-3 bedroom homes with luxury amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Rye Bunker Hill",
  "property_seo_description_residentaccess": "Unlock convenience at Rye Bunker Hill! Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Garland, TX.",
  "property_seo_title_referafriend": "Refer A Friend | Rye Bunker Hill",
  "property_seo_description_referafriend": "Refer a friend to Rye Bunker Hill in Garland, TX! Great friends make great neighbors—share the joy of your vibrant community today! 🌟",
  "property_seo_title_scheduletour": "Schedule a Tour | Rye Bunker Hill",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at Rye Bunker Hill in Garland, TX. Schedule your tour now and envision your dream home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Rye Bunker Hill",
  "property_seo_description_privacy": "Secure your peace of mind at Rye Bunker Hill. Learn how we protect your information in our privacy policy. Your trust matters—see the details here!",
  "property_seo_title_accessibility": "Website Accessibility | Rye Bunker Hill",
  "property_seo_description_accessibility": "Embrace a welcoming home at Rye Bunker Hill in Garland, TX. Our commitment to digital inclusion ensures everyone can access our community with ease.",
  "property_seo_title_sitemap": "Sitemap | Rye Bunker Hill",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Rye Bunker Hill in Garland, TX! Our sitemap makes finding your perfect apartment a breeze. Join us today!",
  "property_seo_title_thankyou": "Thank You | Rye Bunker Hill",
  "property_seo_description_thankyou": "Thank you for your interest in Rye Bunker Hill! Our team will reach out soon to help you find your perfect home in Garland, TX. Stay tuned!",
  "property_seo_title_pets": "Pet-Friendly Apartments in Garland, TX | Rye",
  "property_seo_description_pets": "Explore pet-friendly apartments in Garland at Rye Bunker Hill with an on-site dog park and pet spa. View our current pet policy.",
  "property_updated_at": "1793628768811",
  "amenities": [
    {
      "id": "custom_4be0908b-1f83-4211-8765-b5e6d15ddf72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659655",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43ccf425-2236-4aba-9994-f711a35d3518",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659649",
      "title": "Resort-Style Saltwater Pool with Sun Shelves",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01006-d0ff-74d1-8fd5-daecef223c3f.webp",
      "amenity_image_media": {
        "alt_text": "Luxury apartment community with a sparkling swimming pool and lounge chairs at twilight.",
        "public_id": "01a01006-d0ff-74d1-8fd5-daecef223c3f",
        "storage_key": "property/6767906449167585/01a01006-d0ff-74d1-8fd5-daecef223c3f.webp",
        "width": 3072,
        "height": 1728
      },
      "amenity_image_alt_text": "an aerial view of a resort style salt water pool with lounge chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da0ec1f0-dff2-47f6-91ee-207e6e446958",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659645",
      "title": "Modern Clubhouse with Private Work Pods, Coffee Bar, and Wi-Fi throughout",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23c99868-33ea-4aa8-bc9a-d15c42e43585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659646",
      "title": "Clubroom with Golf Simulator, Billiards Table, Media Center, Fireplace and Entertainment Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f789d70-8ee0-4084-81df-b0256f6daba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659648",
      "title": "State-of-the-art Fitness Center",
      "amount": "false",
      "description": "Equipped with weight and cardio equipment, yoga, spin room and dedicated playroom",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02ac4dd5-fb57-4401-9838-2e319d4f506b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659650",
      "title": "Pool-Side Cabanas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01006-eb62-7092-b64d-7be5afad4776.webp",
      "amenity_image_media": {
        "alt_text": "Rendering of an outdoor lounge area with a pool, cabana, and people relaxing.",
        "public_id": "01a01006-eb62-7092-b64d-7be5afad4776",
        "storage_key": "property/6767906449167585/01a01006-eb62-7092-b64d-7be5afad4776.webp",
        "width": 3072,
        "height": 1728
      },
      "amenity_image_alt_text": "a rendering of a building with a pool in the foreground and people sitting at tables and chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aebe3c76-1ea0-4ea3-97a3-383ec179363d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659651",
      "title": "Multiple Grilling Stations, Lounge Seating, Turf Gaming Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3dba9ac1-aa66-4022-b1f4-a8f2847c9784",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659652",
      "title": "Pickleball Courts",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01006-bc33-7204-806a-bfcaa2a959e8.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor lounge area with fire pits and chairs, adjacent to a pickleball court with people playing.",
        "public_id": "01a01006-bc33-7204-806a-bfcaa2a959e8",
        "storage_key": "property/6767906449167585/01a01006-bc33-7204-806a-bfcaa2a959e8.webp",
        "width": 3072,
        "height": 1728
      },
      "amenity_image_alt_text": "an aerial view of a pickleball courts and fire pits with an apartment building in the background",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_805f838b-272f-48df-98db-62d67f2834df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659653",
      "title": "Dog Park & Pet Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b03a07c-9548-44b1-b610-66a2de81e5e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659654",
      "title": "Electrical Vehicle Charging Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7a613b2f-9081-4c3e-a154-4d2c5d4f2f14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659656",
      "title": "Direct Access to the City of Garland Regional Trail System",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69975ae7-e4ec-4697-9aeb-957352c4d9a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659657",
      "title": "Valet Trash",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7557c435-4dae-49f1-9972-c0e7a98a3896",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291001",
      "title": "Enclosed building corridors with A/C and elevator service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c55b971-5def-4db8-83fe-5decefc6d628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121381102",
      "title": "Golf Simulator",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c703a06-b32d-4290-b955-3d23cc909c92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "122169248",
      "title": "Flexible Rent Payment Options",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ced49608-509c-46f3-9051-4a46b7adddf8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659634",
      "title": "Hardwood-Style Flooring in Main Living Areas",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be8f2fb1-1eaf-4e65-b8cc-d32341446a95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659635",
      "title": "Plush Carpet in Bedrooms and Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f2c7df2b-6451-4ca5-86a1-cdd3cf1e5faf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291051",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b5bfd894-5486-4b6f-af2f-a8ae85f5613d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291050",
      "title": "Extra Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c75ec09-885b-48c3-a8c2-69bde55d9f41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291023",
      "title": "GE® ENERGY STAR® stainless steel appliance package",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_492b2fd5-0b60-4911-ac13-c6a1dd0e7098",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659640",
      "title": "Farmhouse Kitchen Sink with Black Goose-Neck Faucet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4812997d-de17-49bd-a997-f11527ca4f35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291017",
      "title": "Chef Inspired Kitchen",
      "amount": "false",
      "description": "With large island, wrap-around bar or open island with built-in floating shelves",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b82a0d2-cddd-4e89-af4d-808daea0c2de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659642",
      "title": "Quartz Countertops with Backsplash",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6309ff6d-aec3-48bc-b066-7c84de47e03c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291046",
      "title": "Prewired for technology and in-home USB ports",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67634a02-76eb-4742-805f-569cc3ad794b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659638",
      "title": "Tile Flooring in Bathrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b79bec5a-516c-42e0-b5ef-128934ed9d4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291031",
      "title": "Floor-to-ceiling tile surround at all baths and showers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4b413452-81be-434e-a05a-b1610163c585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291022",
      "title": "Dual-tone custom cabinetry with under-cabinet lighting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c58cdba0-7068-48a9-a9be-7c0300b16ccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659590",
      "title": "Top Floor",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb0fadc5-d10f-4535-9296-a91bfef88387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659591",
      "title": "Located Close to Amenities",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fbf16550-8cf1-4833-9114-c68533df03b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659592",
      "title": "Accessible",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0a675119-bb02-4c20-b12a-dcc96ddb8364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659609",
      "title": "Premium View",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df480afd-7bbd-489b-8c76-d19194bf4004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "120659629",
      "title": "Near Elevator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66203269-3624-45c3-a8ec-90aa972b1fc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291029",
      "title": "Spa-inspired bathrooms with quartz countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2aaebf4-8e53-471f-b219-bb6f5dcf7045",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121291040",
      "title": "Urban Mudroom*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b218d983-b6ef-4f84-9554-492ee66656b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "121738005",
      "title": "ADA Unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_71afde3b-335c-45e2-affc-761479b0cc47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Backsplashes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc579178-45ac-46a9-a1b3-45dbe1a87fb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "false",
      "title": "Lake Pavilion View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_25bc76ec-a103-4546-9541-a0af21457999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "false",
      "title": "In-home Washers & Dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_440254e0-714c-4811-bbf7-4a29de1c9c0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "external_id": "false",
      "title": "Patios and Balconies",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_f764dbcfe69fd837ba74a8ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01006-9378-759e-8016-f608ac1e7c59.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with tanning ledges and lounge chairs.",
        "public_id": "01a01006-9378-759e-8016-f608ac1e7c59",
        "storage_key": "property/6767906449167585/01a01006-9378-759e-8016-f608ac1e7c59.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, featuring integrated tanning ledges and comfortable lounge chairs for ultimate relaxation.",
      "link": "false",
      "alt_text": "Luxury swimming pool with tanning ledges and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/02-4401 Bunker Hill Rd -13.jpg"
    },
    {
      "id": "ec_b20423219f8679e0067bb971",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-069b-7644-a5e9-8b1c27484ccc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools",
        "public_id": "01a01007-069b-7644-a5e9-8b1c27484ccc",
        "storage_key": "property/6767906449167585/01a01007-069b-7644-a5e9-8b1c27484ccc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring white cabinetry, stainless steel appliances, a large island with bar stools, and pendant lighting.",
      "link": "false",
      "alt_text": "Modern kitchen with island and bar stools",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/007-DSC05071-Edit.jpg"
    },
    {
      "id": "ec_a615f9daa249478435784947",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-06de-72bf-a683-5537f2a81515.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and apartment buildings in the background.",
        "public_id": "01a01007-06de-72bf-a683-5537f2a81515",
        "storage_key": "property/6767906449167585/01a01007-06de-72bf-a683-5537f2a81515.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor lounge area, complete with comfortable seating and a fire pit. Enjoy the resort-style amenities surrounded by our beautiful apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor seating area with fire pit and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/40-4401 Bunker Hill Rd -39.jpg"
    },
    {
      "id": "ec_086da297199208bdc23abad9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-0668-77e0-b04d-1020a905a2cb.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with pendant lights and open living area.",
        "public_id": "01a01007-0668-77e0-b04d-1020a905a2cb",
        "storage_key": "property/6767906449167585/01a01007-0668-77e0-b04d-1020a905a2cb.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment layout featuring a gourmet kitchen island, comfortable living room, and elegant finishes.",
      "link": "false",
      "alt_text": "Modern kitchen island with pendant lights and open living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/013-DSC05116-Edit.jpg"
    },
    {
      "id": "ec_4517761bf04b0b3998b3e589",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-06f5-76ea-92d4-df37b8bab479.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and an island.",
        "public_id": "01a01007-06f5-76ea-92d4-df37b8bab479",
        "storage_key": "property/6767906449167585/01a01007-06f5-76ea-92d4-df37b8bab479.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stunning modern kitchen featuring stainless steel appliances, ample cabinet space, and a large island perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/011-DSC05091.jpg"
    },
    {
      "id": "ec_7648644437d0ceb414a02e0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-087d-7477-a405-d5fda25e0250.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large farmhouse sink.",
        "public_id": "01a01007-087d-7477-a405-d5fda25e0250",
        "storage_key": "property/6767906449167585/01a01007-087d-7477-a405-d5fda25e0250.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring sleek stainless steel appliances, ample storage with white cabinetry, and a stylish farmhouse sink. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a large farmhouse sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/010-DSC05086.jpg"
    },
    {
      "id": "ec_bbfd70409c216efd24217e7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-13fa-73e6-843d-bc1c6bfb5898.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white subway tile backsplash, farmhouse sink, and black faucet.",
        "public_id": "01a01007-13fa-73e6-843d-bc1c6bfb5898",
        "storage_key": "property/6767906449167585/01a01007-13fa-73e6-843d-bc1c6bfb5898.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring a deep farmhouse sink, sleek black faucet, and bright white subway tile backsplash. Perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white subway tile backsplash, farmhouse sink, and black faucet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/023-DSC05176.jpg"
    },
    {
      "id": "ec_a0b56f02205412673ef6c9c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-159e-7694-91b7-f0b7bc9038de.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a large island, stainless steel appliances, and white cabinets.",
        "public_id": "01a01007-159e-7694-91b7-f0b7bc9038de",
        "storage_key": "property/6767906449167585/01a01007-159e-7694-91b7-f0b7bc9038de.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience culinary excellence in this spacious, modern kitchen featuring a large island, stainless steel appliances, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with a large island, stainless steel appliances, and white cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/009-DSC05081-Edit.jpg"
    },
    {
      "id": "ec_1c856ceccafe0e4ae530801f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-16fd-71e9-ad21-efaed0ab346f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "01a01007-16fd-71e9-ad21-efaed0ab346f",
        "storage_key": "property/6767906449167585/01a01007-16fd-71e9-ad21-efaed0ab346f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and well-equipped kitchen featuring sleek cabinetry, a farmhouse sink, and a built-in desk area.",
      "link": "false",
      "alt_text": "Modern kitchen with white countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/012-DSC05101.jpg"
    },
    {
      "id": "ec_b35df846560c3d16c40a751e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-1765-775c-b34a-6fd2d7f1789c.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and integrated desk.",
        "public_id": "01a01007-1765-775c-b34a-6fd2d7f1789c",
        "storage_key": "property/6767906449167585/01a01007-1765-775c-b34a-6fd2d7f1789c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and functionality in our spacious kitchens, featuring premium stainless steel appliances and a convenient integrated workspace.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with island, stainless steel appliances, and integrated desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/006-DSC05066.jpg"
    },
    {
      "id": "ec_0db51b7c69c2cedac790ae42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-1825-7613-8479-66c66136ac99.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, bar stools, stainless steel appliances, and white cabinetry.",
        "public_id": "01a01007-1825-7613-8479-66c66136ac99",
        "storage_key": "property/6767906449167585/01a01007-1825-7613-8479-66c66136ac99.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with bar stools, sleek stainless steel appliances, and ample white cabinetry for storage.",
      "link": "false",
      "alt_text": "Modern kitchen with island, bar stools, stainless steel appliances, and white cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/008-DSC05076-Edit.jpg"
    },
    {
      "id": "ec_9be1c9e03ebc85fb8354f154",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-1f08-77cf-acb6-0f75c8a857e2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and an island.",
        "public_id": "01a01007-1f08-77cf-acb6-0f75c8a857e2",
        "storage_key": "property/6767906449167585/01a01007-1f08-77cf-acb6-0f75c8a857e2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience chic, modern living in this fully equipped kitchen, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/081-DSC05680.jpg"
    },
    {
      "id": "ec_076259b86f9cc51d2d349dfb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-21e7-76c6-8a27-0e440caa0221.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a farmhouse sink.",
        "public_id": "01a01007-21e7-76c6-8a27-0e440caa0221",
        "storage_key": "property/6767906449167585/01a01007-21e7-76c6-8a27-0e440caa0221.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Contemporary kitchen featuring sleek white cabinetry, a large stainless steel farmhouse sink, and modern appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a farmhouse sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/026-DSC05196.jpg"
    },
    {
      "id": "ec_1c66349b8838fc9ca06ae114",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-24b5-7208-88a3-933a6d5de93f.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, accent chairs, coffee table, and floor lamp.",
        "public_id": "01a01007-24b5-7208-88a3-933a6d5de93f",
        "storage_key": "property/6767906449167585/01a01007-24b5-7208-88a3-933a6d5de93f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a modern sectional sofa, comfortable accent chairs, and elegant decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a large sectional sofa, accent chairs, coffee table, and floor lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/014-DSC05121.jpg"
    },
    {
      "id": "ec_314dfb5649f30e7629f429ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-25d3-76b9-96bc-8b43aeb18559.webp",
      "image_media": {
        "alt_text": "A stylish living room with a sectional sofa, accent chair, coffee table, and artwork.",
        "public_id": "01a01007-25d3-76b9-96bc-8b43aeb18559",
        "storage_key": "property/6767906449167585/01a01007-25d3-76b9-96bc-8b43aeb18559.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living space, perfect for entertaining or enjoying a quiet evening at home.",
      "link": "false",
      "alt_text": "A stylish living room with a sectional sofa, accent chair, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/015-DSC05126.jpg"
    },
    {
      "id": "ec_c1355a44f28690ab05a76460",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-28f3-770d-af23-1ccd716e3174.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a01007-28f3-770d-af23-1ccd716e3174",
        "storage_key": "property/6767906449167585/01a01007-28f3-770d-af23-1ccd716e3174.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning resort-style pool, perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/003-DJI_20240306153930_0388_D V2.jpg"
    },
    {
      "id": "ec_b9e8b5fe237217a1fb27da53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-2b53-764b-bb44-f9f7e811d201.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with covered parking and a sunset sky.",
        "public_id": "01a01007-2b53-764b-bb44-f9f7e811d201",
        "storage_key": "property/6767906449167585/01a01007-2b53-764b-bb44-f9f7e811d201.webp",
        "width": 1800,
        "height": 1400
      },
      "title": "Community",
      "description": "View of a contemporary apartment complex featuring covered parking and balconies against a vibrant sunset backdrop.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with covered parking and a sunset sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/001-DJI_20240306154209_0411_D-Twilight.jpg"
    },
    {
      "id": "ec_331c9bd17bb55e2881d9f131",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-2d40-76ca-a7d4-5008a656dbf9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with a large pond and walking paths.",
        "public_id": "01a01007-2d40-76ca-a7d4-5008a656dbf9",
        "storage_key": "property/6767906449167585/01a01007-2d40-76ca-a7d4-5008a656dbf9.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Experience luxury living with scenic views of the pond and surrounding green spaces. These modern apartment buildings offer a vibrant community atmosphere.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with a large pond and walking paths.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/002-DJI_20240306154401_0418_D V2.jpg"
    },
    {
      "id": "ec_431e73b29605fccb141f5b1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-3174-704c-9147-6bf6714d8e47.webp",
      "image_media": {
        "alt_text": "Modern living room with plush seating, abstract art, and a coffee table.",
        "public_id": "01a01007-3174-704c-9147-6bf6714d8e47",
        "storage_key": "property/6767906449167585/01a01007-3174-704c-9147-6bf6714d8e47.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Step into comfort in this stylish living space featuring plush seating, a modern coffee table, and elegant decor.",
      "link": "false",
      "alt_text": "Modern living room with plush seating, abstract art, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/021-DSC05161.jpg"
    },
    {
      "id": "ec_8b53385e1581f8bac69aabaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-323a-752d-8c2b-0410b51d4c4e.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, and artwork.",
        "public_id": "01a01007-323a-752d-8c2b-0410b51d4c4e",
        "storage_key": "property/6767906449167585/01a01007-323a-752d-8c2b-0410b51d4c4e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable couch, a modern coffee table, and tasteful horse-themed artwork, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with a couch, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/085-DSC05740.jpg"
    },
    {
      "id": "ec_c8ac600511e5828918d20363",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-3703-7024-bacb-2d8724ff0142.webp",
      "image_media": {
        "alt_text": "Built-in desk with shelves and a chair.",
        "public_id": "01a01007-3703-7024-bacb-2d8724ff0142",
        "storage_key": "property/6767906449167585/01a01007-3703-7024-bacb-2d8724ff0142.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "This built-in desk features a modern design with ample shelving and a comfortable workspace, perfect for home office needs.",
      "link": "false",
      "alt_text": "Built-in desk with shelves and a chair.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/024-DSC05181.jpg"
    },
    {
      "id": "ec_f821efb37a4edc28f8665920",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-3b7c-708c-92cb-7bd88a930275.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and view of living room.",
        "public_id": "01a01007-3b7c-708c-92cb-7bd88a930275",
        "storage_key": "property/6767906449167585/01a01007-3b7c-708c-92cb-7bd88a930275.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable king-size bed, stylish dresser, and a view into the adjacent living area, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dresser, and view of living room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/030-DSC05241.jpg"
    },
    {
      "id": "ec_57943041f6bbf1b7fc325a21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-3c7e-772c-8632-7edb30b9fc59.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-sized bed, orange quilt, and large window with blinds.",
        "public_id": "01a01007-3c7e-772c-8632-7edb30b9fc59",
        "storage_key": "property/6767906449167585/01a01007-3c7e-772c-8632-7edb30b9fc59.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms, featuring plush bedding and ample natural light.",
      "link": "false",
      "alt_text": "Stylish bedroom with a queen-sized bed, orange quilt, and large window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/027-DSC05216.jpg"
    },
    {
      "id": "ec_7b6aad9de649fc5e439c89ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4053-70ba-a958-7d84b232ff20.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a large bed, ceiling fan, and an ensuite bathroom visible through an open doorway.",
        "public_id": "01a01007-4053-70ba-a958-7d84b232ff20",
        "storage_key": "property/6767906449167585/01a01007-4053-70ba-a958-7d84b232ff20.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, modern ceiling fan, and a convenient ensuite bathroom.",
      "link": "false",
      "alt_text": "Stylish bedroom with a large bed, ceiling fan, and an ensuite bathroom visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/028-DSC05226.jpg"
    },
    {
      "id": "ec_780a8dc4284fecbcb52f7214",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4195-717e-a21d-81069ceeb9b1.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, mirror, plant, and ceiling fan. View of closet and dining area.",
        "public_id": "01a01007-4195-717e-a21d-81069ceeb9b1",
        "storage_key": "property/6767906449167585/01a01007-4195-717e-a21d-81069ceeb9b1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Stylish bedroom featuring a modern dresser, arched mirror, and a large potted plant. Ceiling fan overhead and a view into the closet and dining area.",
      "link": "false",
      "alt_text": "Bedroom with dresser, mirror, plant, and ceiling fan. View of closet and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/029-DSC05231.jpg"
    },
    {
      "id": "ec_ae9511bd84d52680fcf9e17e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-42e0-77ba-9bed-a2184b2acc08.webp",
      "image_media": {
        "alt_text": "Walk-in closet with a bathrobe hanging and decorative baskets on shelves.",
        "public_id": "01a01007-42e0-77ba-9bed-a2184b2acc08",
        "storage_key": "property/6767906449167585/01a01007-42e0-77ba-9bed-a2184b2acc08.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring organized shelving, a plush bathrobe, and decorative baskets, perfect for storing your essentials.",
      "link": "false",
      "alt_text": "Walk-in closet with a bathrobe hanging and decorative baskets on shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/035-DSC05311.jpg"
    },
    {
      "id": "ec_1733779856c0264a5ff87ef5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-485c-76b9-8776-6117983fa3cf.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity and glimpse of bedroom.",
        "public_id": "01a01007-485c-76b9-8776-6117983fa3cf",
        "storage_key": "property/6767906449167585/01a01007-485c-76b9-8776-6117983fa3cf.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Chic bathroom featuring a spacious double vanity with sleek fixtures and a peek into the comfortable bedroom.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity and glimpse of bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/033-DSC05276.jpg"
    },
    {
      "id": "ec_a485c21e1a06770fc0541613",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4851-757b-9b37-5481fe27dcb6.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in glass shower and view of bedroom.",
        "public_id": "01a01007-4851-757b-9b37-5481fe27dcb6",
        "storage_key": "property/6767906449167585/01a01007-4851-757b-9b37-5481fe27dcb6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience the luxury of this modern bathroom, featuring a spacious walk-in shower with elegant tile work, and a peek into the comfortable bedroom.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in glass shower and view of bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/034-DSC05295.jpg"
    },
    {
      "id": "ec_015fafbf3856ab3412b07927",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4e40-724c-a2fa-edc8d1295ee3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in closet, bathtub, and shower.",
        "public_id": "01a01007-4e40-724c-a2fa-edc8d1295ee3",
        "storage_key": "property/6767906449167585/01a01007-4e40-724c-a2fa-edc8d1295ee3.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a spacious walk-in closet and a clean, modern bathroom with a bathtub and shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a walk-in closet, bathtub, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/045-DSC05411.jpg"
    },
    {
      "id": "ec_37321eddac63b3a73e327bb9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4f56-738c-9e03-9fda6847a99a.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with two sinks and a walk-in shower.",
        "public_id": "01a01007-4f56-738c-9e03-9fda6847a99a",
        "storage_key": "property/6767906449167585/01a01007-4f56-738c-9e03-9fda6847a99a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Luxurious double vanity bathroom featuring two sinks, modern fixtures, and a spacious walk-in shower with tiled walls.",
      "link": "false",
      "alt_text": "Double vanity bathroom with two sinks and a walk-in shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/032-DSC05270.jpg"
    },
    {
      "id": "ec_9d218d456a42a0d93f5a2ccd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-4e17-77ea-90a8-beb70dacb971.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, dual sinks, large mirror, and walk-in closet.",
        "public_id": "01a01007-4e17-77ea-90a8-beb70dacb971",
        "storage_key": "property/6767906449167585/01a01007-4e17-77ea-90a8-beb70dacb971.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a double vanity with dual sinks and ample storage, complemented by a walk-in closet for convenience.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, dual sinks, large mirror, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/031-DSC05261.jpg"
    },
    {
      "id": "ec_cc8100fd3c9c0982e863de24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-5489-76ad-9053-eb17f6839c35.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table, comfortable seating, and large windows overlooking a swimming pool.",
        "public_id": "01a01007-5489-76ad-9053-eb17f6839c35",
        "storage_key": "property/6767906449167585/01a01007-5489-76ad-9053-eb17f6839c35.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a billiards table, ample seating, and views of the resort-style pool.",
      "link": "false",
      "alt_text": "Modern lounge area with a pool table, comfortable seating, and large windows overlooking a swimming pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/100-DSC05920.jpg"
    },
    {
      "id": "ec_02d2098da3ff136cfad8cb56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-54fc-75f8-a6a2-a547e0ba04b4.webp",
      "image_media": {
        "alt_text": "Modern community kitchen and lounge area with a large table and bar seating.",
        "public_id": "01a01007-54fc-75f8-a6a2-a547e0ba04b4",
        "storage_key": "property/6767906449167585/01a01007-54fc-75f8-a6a2-a547e0ba04b4.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather and socialize in the stylish community kitchen and lounge, featuring a spacious table, bar seating, and a well-equipped kitchenette.",
      "link": "false",
      "alt_text": "Modern community kitchen and lounge area with a large table and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/103-DSC05970.jpg"
    },
    {
      "id": "ec_e6403143633b88ea6f58420a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-5a62-704b-8881-b6e9e9abf8b1.webp",
      "image_media": {
        "alt_text": "Work pod 2 signage outside a shared workspace.",
        "public_id": "01a01007-5a62-704b-8881-b6e9e9abf8b1",
        "storage_key": "property/6767906449167585/01a01007-5a62-704b-8881-b6e9e9abf8b1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "This image showcases a modern community amenity with a designated 'Work Pod 2' area, featuring a desk and chair visible through glass doors, alongside stylish decor and a printer station.",
      "link": "false",
      "alt_text": "Work pod 2 signage outside a shared workspace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/104-DSC05991.jpg"
    },
    {
      "id": "ec_fa9d36e2408f368e4b4e2b69",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-5b75-75ba-a308-bf7a4632f828.webp",
      "image_media": {
        "alt_text": "Children's reading nook with hexagonal seating and a small table and chairs.",
        "public_id": "01a01007-5b75-75ba-a308-bf7a4632f828",
        "storage_key": "property/6767906449167585/01a01007-5b75-75ba-a308-bf7a4632f828.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "A cozy children's reading nook featuring unique hexagonal seating areas with comfortable cushions, a small table, and chairs. This space offers a playful and inviting atmosphere for young residents.",
      "link": "false",
      "alt_text": "Children's reading nook with hexagonal seating and a small table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/122-DSC06191.jpg"
    },
    {
      "id": "ec_7565d1242da3fd7f3c32f78d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-5ba6-7538-adbf-ebe7e8b508c0.webp",
      "image_media": {
        "alt_text": "Modern lounge area with honeycomb-shaped seating next to a gym with cardio equipment.",
        "public_id": "01a01007-5ba6-7538-adbf-ebe7e8b508c0",
        "storage_key": "property/6767906449167585/01a01007-5ba6-7538-adbf-ebe7e8b508c0.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax in the stylish lounge area featuring unique honeycomb seating, or stay active in the well-equipped fitness center overlooking the pool.",
      "link": "false",
      "alt_text": "Modern lounge area with honeycomb-shaped seating next to a gym with cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/123-DSC06211.jpg"
    },
    {
      "id": "ec_423b15415ac3370e2dcb38ca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-60db-75af-8c2e-052f0842f7e5.webp",
      "image_media": {
        "alt_text": "Game room with table and chairs, view of gym and pool through windows.",
        "public_id": "01a01007-60db-75af-8c2e-052f0842f7e5",
        "storage_key": "property/6767906449167585/01a01007-60db-75af-8c2e-052f0842f7e5.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy the game room with a table and chairs, plus views of the fitness center and pool. Perfect for resident relaxation and recreation.",
      "link": "false",
      "alt_text": "Game room with table and chairs, view of gym and pool through windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/124-DSC06226.jpg"
    },
    {
      "id": "ec_9a16709e6703ef8eb3c751c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-6161-75e4-8659-9ce8cf893d08.webp",
      "image_media": {
        "alt_text": "Gym area with weight racks, kettlebells, medicine balls, and weight benches.",
        "public_id": "01a01007-6161-75e4-8659-9ce8cf893d08",
        "storage_key": "property/6767906449167585/01a01007-6161-75e4-8659-9ce8cf893d08.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "false",
      "alt_text": "Gym area with weight racks, kettlebells, medicine balls, and weight benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/118-DSC06166.jpg"
    },
    {
      "id": "ec_34b27593bf8974616b26618e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-67c6-74cf-9992-c136cc9061dc.webp",
      "image_media": {
        "alt_text": "Gym with cardio equipment, including a rowing machine and stationary bikes, overlooking the outdoor pool area.",
        "public_id": "01a01007-67c6-74cf-9992-c136cc9061dc",
        "storage_key": "property/6767906449167585/01a01007-67c6-74cf-9992-c136cc9061dc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier cardio equipment and a view of the sparkling pool.",
      "link": "false",
      "alt_text": "Gym with cardio equipment, including a rowing machine and stationary bikes, overlooking the outdoor pool area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/119-DSC06171.jpg"
    },
    {
      "id": "ec_506831b108517aaad992dc25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-67d0-7578-bd52-6e224b2646d1.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment",
        "public_id": "01a01007-67d0-7578-bd52-6e224b2646d1",
        "storage_key": "property/6767906449167585/01a01007-67d0-7578-bd52-6e224b2646d1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring modern weight machines and cardio equipment for a complete workout experience.",
      "link": "false",
      "alt_text": "Gym with weight machines and cardio equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/121-DSC06186.jpg"
    },
    {
      "id": "ec_e904379d40b367e50a7199df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-6842-77fb-8b0b-784ac20a1d25.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a modern gym with large windows overlooking the pool and apartment buildings.",
        "public_id": "01a01007-6842-77fb-8b0b-784ac20a1d25",
        "storage_key": "property/6767906449167585/01a01007-6842-77fb-8b0b-784ac20a1d25.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring top-tier cardio equipment and stunning views.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a modern gym with large windows overlooking the pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/120-DSC06181.jpg"
    },
    {
      "id": "ec_7a387a31229a4d5b22b1d801",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-6c74-7339-8e88-a03c910fb65d.webp",
      "image_media": {
        "alt_text": "Spacious gym with treadmills, ellipticals, weight machines, and dumbbells.",
        "public_id": "01a01007-6c74-7339-8e88-a03c910fb65d",
        "storage_key": "property/6767906449167585/01a01007-6c74-7339-8e88-a03c910fb65d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, fully equipped with cardio machines, weight training equipment, and free weights. ",
      "link": "false",
      "alt_text": "Spacious gym with treadmills, ellipticals, weight machines, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/115-DSC06141.jpg"
    },
    {
      "id": "ec_79c665570cdca4bdaae1064b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-6e68-7369-a7b2-c4a8bf31baea.webp",
      "image_media": {
        "alt_text": "Gym with weight benches, dumbbells, and mirrored walls.",
        "public_id": "01a01007-6e68-7369-a7b2-c4a8bf31baea",
        "storage_key": "property/6767906449167585/01a01007-6e68-7369-a7b2-c4a8bf31baea.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a full range of cardio and strength training equipment, including free weights and machines. Perfect for an invigorating workout.",
      "link": "false",
      "alt_text": "Gym with weight benches, dumbbells, and mirrored walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/116-DSC06146.jpg"
    },
    {
      "id": "ec_d1f60b3bfcf3c02a665d0964",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-7514-734a-927c-677167a13171.webp",
      "image_media": {
        "alt_text": "Modern apartment community gym with treadmills, weight machines, dumbbells, and benches.",
        "public_id": "01a01007-7514-734a-927c-677167a13171",
        "storage_key": "property/6767906449167585/01a01007-7514-734a-927c-677167a13171.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, strength training machines, free weights, and benches, designed for resident use.",
      "link": "false",
      "alt_text": "Modern apartment community gym with treadmills, weight machines, dumbbells, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/114-DSC06131.jpg"
    },
    {
      "id": "ec_da6008b1132718486a851637",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-74ee-7376-97f8-80d70c1714c6.webp",
      "image_media": {
        "alt_text": "Well-equipped gym with weight machines, dumbbells, and cardio equipment.",
        "public_id": "01a01007-74ee-7376-97f8-80d70c1714c6",
        "storage_key": "property/6767906449167585/01a01007-74ee-7376-97f8-80d70c1714c6.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a full range of strength and cardio equipment to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "Well-equipped gym with weight machines, dumbbells, and cardio equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/117-DSC06151.jpg"
    },
    {
      "id": "ec_8f5a131fc4d3d1afaefafe2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-7960-738d-a4c8-c0309ca55128.webp",
      "image_media": {
        "alt_text": "Outdoor dog washing station with ramp and showerhead, fenced area, and apartment buildings in the background.",
        "public_id": "01a01007-7960-738d-a4c8-c0309ca55128",
        "storage_key": "property/6767906449167585/01a01007-7960-738d-a4c8-c0309ca55128.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Groom your furry friend at our convenient outdoor dog washing station, complete with a ramp and showerhead. A fantastic amenity for pet owners.",
      "link": "false",
      "alt_text": "Outdoor dog washing station with ramp and showerhead, fenced area, and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/145-DSC06459 V2.jpg"
    },
    {
      "id": "ec_42a6b1458f1b25d21dce8ce2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-7b06-750e-b84c-2f664d70319e.webp",
      "image_media": {
        "alt_text": "Apartment community dog park with agility equipment.",
        "public_id": "01a01007-7b06-750e-b84c-2f664d70319e",
        "storage_key": "property/6767906449167585/01a01007-7b06-750e-b84c-2f664d70319e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, complete with agility equipment and shaded seating for your furry friends.",
      "link": "false",
      "alt_text": "Apartment community dog park with agility equipment.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/146-DSC06484 V2-Edit.jpg"
    },
    {
      "id": "ec_4111b9bedc93b8406a4da51e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-7c8a-702e-8bd6-1fbb0e994ec2.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and tennis courts in the background.",
        "public_id": "01a01007-7c8a-702e-8bd6-1fbb0e994ec2",
        "storage_key": "property/6767906449167585/01a01007-7c8a-702e-8bd6-1fbb0e994ec2.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment for your furry friends. Nearby, you'll find tennis courts for outdoor recreation.",
      "link": "false",
      "alt_text": "Dog park with agility equipment and tennis courts in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/147-DSC06499 V2.jpg"
    },
    {
      "id": "ec_b4952ebc13842d6afee0b097",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-812a-7798-adb5-695aed40762f.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, benches, and a building in the background.",
        "public_id": "01a01007-812a-7798-adb5-695aed40762f",
        "storage_key": "property/6767906449167585/01a01007-812a-7798-adb5-695aed40762f.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility features and ample space for your furry friends to play.",
      "link": "false",
      "alt_text": "Dog park with agility equipment, benches, and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/148-DSC06514 V2.jpg"
    },
    {
      "id": "ec_8f1b34db78afe27e4bb21c43",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-8192-7172-bb9f-bdc895512c54.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "01a01007-8192-7172-bb9f-bdc895512c54",
        "storage_key": "property/6767906449167585/01a01007-8192-7172-bb9f-bdc895512c54.webp",
        "width": 1200,
        "height": 675
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/005-DJI_20240306154116_0406_D V2-Edit.jpg"
    },
    {
      "id": "ec_caaad68722c19855090d2e2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-86b3-77e1-93ce-620a556a5a6d.webp",
      "image_media": {
        "alt_text": "Covered patio with seating and a pool and apartment buildings in the background.",
        "public_id": "01a01007-86b3-77e1-93ce-620a556a5a6d",
        "storage_key": "property/6767906449167585/01a01007-86b3-77e1-93ce-620a556a5a6d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy resort-style living with this stunning outdoor patio, complete with comfortable seating and a refreshing pool. Perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Covered patio with seating and a pool and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/140-DSC06424.jpg"
    },
    {
      "id": "ec_b731c7fc30b521f894956f73",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-896d-77ab-85e5-013e934fa60a.webp",
      "image_media": {
        "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "01a01007-896d-77ab-85e5-013e934fa60a",
        "storage_key": "property/6767906449167585/01a01007-896d-77ab-85e5-013e934fa60a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with comfortable lounge chairs and refreshing water features. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/137-DSC06369.jpg"
    },
    {
      "id": "ec_62271dd74a5fe9677bd8709b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-8b48-7024-ac06-60bfa7caf548.webp",
      "image_media": {
        "alt_text": "Multifamily property with pickleball and tennis courts, community buildings, and parking.",
        "public_id": "01a01007-8b48-7024-ac06-60bfa7caf548",
        "storage_key": "property/6767906449167585/01a01007-8b48-7024-ac06-60bfa7caf548.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation on the pickleball and tennis courts at this multifamily property. The community also features convenient parking and modern apartment buildings.",
      "link": "false",
      "alt_text": "Multifamily property with pickleball and tennis courts, community buildings, and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/149-DSC06549.jpg"
    },
    {
      "id": "ec_9aca5133b0b696a9c36afde0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-91e4-70ce-a663-e87daa85ff4f.webp",
      "image_media": {
        "alt_text": "Rye Bunker Hill apartment building exterior with monument sign.",
        "public_id": "01a01007-91e4-70ce-a663-e87daa85ff4f",
        "storage_key": "property/6767906449167585/01a01007-91e4-70ce-a663-e87daa85ff4f.webp",
        "width": 1800,
        "height": 1400
      },
      "title": "Community",
      "description": "Welcome to Rye Bunker Hill, a modern apartment community featuring beautiful architecture and a welcoming monument sign.",
      "link": "false",
      "alt_text": "Rye Bunker Hill apartment building exterior with monument sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/153-DSC06589-Edit-Twilight.jpg"
    },
    {
      "id": "ec_6e1307bee2d6b4212ea7488b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-8fcf-772f-9229-ad9672921a25.webp",
      "image_media": {
        "alt_text": "Luxury apartment building with a resort-style swimming pool and lounge area.",
        "public_id": "01a01007-8fcf-772f-9229-ad9672921a25",
        "storage_key": "property/6767906449167585/01a01007-8fcf-772f-9229-ad9672921a25.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor swimming pool, surrounded by comfortable lounge chairs and scenic views. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Luxury apartment building with a resort-style swimming pool and lounge area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/01-edit-1.jpg"
    },
    {
      "id": "ec_8f41ccaf5afba19a63a98f22",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-9402-7089-8fc5-5688f1d3794f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with submerged lounge chairs and a covered patio with seating.",
        "public_id": "01a01007-9402-7089-8fc5-5688f1d3794f",
        "storage_key": "property/6767906449167585/01a01007-9402-7089-8fc5-5688f1d3794f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style pool, complete with submerged lounge chairs and a shaded pavilion featuring comfortable seating and dining areas.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with submerged lounge chairs and a covered patio with seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/03-4401 Bunker Hill Rd -14.jpg"
    },
    {
      "id": "ec_b165d7ab292609c91d929e4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-94bb-71e9-af48-b3caf369b523.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana area in front of apartment buildings.",
        "public_id": "01a01007-94bb-71e9-af48-b3caf369b523",
        "storage_key": "property/6767906449167585/01a01007-94bb-71e9-af48-b3caf369b523.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana area, perfect for relaxing on sunny days.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana area in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/04-4401 Bunker Hill Rd -15.jpg"
    },
    {
      "id": "ec_20d2ba23b8911abcd6e6b4be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-983b-70ed-9ab9-5f9f25d611d2.webp",
      "image_media": {
        "alt_text": "In-pool lounge chairs at a covered outdoor seating area next to a modern apartment building.",
        "public_id": "01a01007-983b-70ed-9ab9-5f9f25d611d2",
        "storage_key": "property/6767906449167585/01a01007-983b-70ed-9ab9-5f9f25d611d2.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in the resort-style swimming pool with in-water lounge chairs and a shaded cabana with seating and dining options.",
      "link": "false",
      "alt_text": "In-pool lounge chairs at a covered outdoor seating area next to a modern apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/07-4401 Bunker Hill Rd -18.jpg"
    },
    {
      "id": "ec_c3a206d9c5a557badeedf46a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-9a96-75d4-a678-1b94d7ba0606.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and a cabana.",
        "public_id": "01a01007-9a96-75d4-a678-1b94d7ba0606",
        "storage_key": "property/6767906449167585/01a01007-9a96-75d4-a678-1b94d7ba0606.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge seating and a shaded cabana.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs, umbrellas, and a cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/10-4401 Bunker Hill Rd -21.jpg"
    },
    {
      "id": "ec_e5055080c0bb86dc20655ef9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-9ed3-744e-80aa-5c5b4e54ef75.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex pool area with lounge chairs and cabana.",
        "public_id": "01a01007-9ed3-744e-80aa-5c5b4e54ef75",
        "storage_key": "property/6767906449167585/01a01007-9ed3-744e-80aa-5c5b4e54ef75.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area. Perfect for soaking up the sun or entertaining guests.",
      "link": "false",
      "alt_text": "Luxury apartment complex pool area with lounge chairs and cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/05-4401 Bunker Hill Rd -16.jpg"
    },
    {
      "id": "ec_71793e99730991c4a88a1579",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-9fdb-728a-8802-6487a5871c83.webp",
      "image_media": {
        "alt_text": "Luxury outdoor swimming pool with lounge chairs and cabana at an apartment complex.",
        "public_id": "01a01007-9fdb-728a-8802-6487a5871c83",
        "storage_key": "property/6767906449167585/01a01007-9fdb-728a-8802-6487a5871c83.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded cabana area. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "false",
      "alt_text": "Luxury outdoor swimming pool with lounge chairs and cabana at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/09-4401 Bunker Hill Rd -20.jpg"
    },
    {
      "id": "ec_7cb0bfd3bb12cd00c8ac1e1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-a3e6-74f9-acf1-715e77ca6ba7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledges and fountains, adjacent to a covered cabana and apartment buildings.",
        "public_id": "01a01007-a3e6-74f9-acf1-715e77ca6ba7",
        "storage_key": "property/6767906449167585/01a01007-a3e6-74f9-acf1-715e77ca6ba7.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool featuring tanning ledges and soothing fountains, perfect for relaxation. The adjacent cabana and modern apartment buildings create a beautiful community setting.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with tanning ledges and fountains, adjacent to a covered cabana and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/08-4401 Bunker Hill Rd -19.jpg"
    },
    {
      "id": "ec_c82045555bb5430365b01b14",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-a4c7-70ee-86b0-124d7b16c6ef.webp",
      "image_media": {
        "alt_text": "Modern swimming pool with submerged lounge chairs and a building with large windows.",
        "public_id": "01a01007-a4c7-70ee-86b0-124d7b16c6ef",
        "storage_key": "property/6767906449167585/01a01007-a4c7-70ee-86b0-124d7b16c6ef.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning swimming pool, complete with comfortable submerged lounge chairs and a stylish modern building backdrop.",
      "link": "false",
      "alt_text": "Modern swimming pool with submerged lounge chairs and a building with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/11-4401 Bunker Hill Rd -22.jpg"
    },
    {
      "id": "ec_0eb79b195fd56e31ad086679",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-a581-707d-8dfd-83d2286dd500.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs, adjacent to apartment buildings.",
        "public_id": "01a01007-a581-707d-8dfd-83d2286dd500",
        "storage_key": "property/6767906449167585/01a01007-a581-707d-8dfd-83d2286dd500.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our resort-style swimming pool, complete with tanning ledges and ample lounge seating. Perfect for soaking up the sun and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with tanning ledges and lounge chairs, adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12-4401 Bunker Hill Rd -23.jpg"
    },
    {
      "id": "ec_dd73bd76d5c73e1d3043dd10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-a846-77d5-a75b-485bc9888e45.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
        "public_id": "01a01007-a846-77d5-a75b-485bc9888e45",
        "storage_key": "property/6767906449167585/01a01007-a846-77d5-a75b-485bc9888e45.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax by our stunning resort-style swimming pool, featuring comfortable lounge chairs and a shaded cabana perfect for entertaining or unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/06-4401 Bunker Hill Rd -17.jpg"
    },
    {
      "id": "ec_cb371611038e773a10d6c339",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-ac3f-778f-9fc8-09666815133b.webp",
      "image_media": {
        "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "01a01007-ac3f-778f-9fc8-09666815133b",
        "storage_key": "property/6767906449167585/01a01007-ac3f-778f-9fc8-09666815133b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax by the pristine outdoor swimming pool, complete with submerged lounge chairs and refreshing water features. An ideal spot to unwind and soak up the sun.",
      "link": "false",
      "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/14-4401 Bunker Hill Rd -12.jpg"
    },
    {
      "id": "ec_3a0d7e91bee993f832cf857e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-ae4b-7485-ada0-fc0001e494d2.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and dining area with seating and ceiling fans.",
        "public_id": "01a01007-ae4b-7485-ada0-fc0001e494d2",
        "storage_key": "property/6767906449167585/01a01007-ae4b-7485-ada0-fc0001e494d2.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining in our spacious outdoor kitchen and lounge area, complete with comfortable seating and overhead fans.",
      "link": "false",
      "alt_text": "Outdoor kitchen and dining area with seating and ceiling fans.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/16-4401 Bunker Hill Rd -3.jpg"
    },
    {
      "id": "ec_c6aa5e0a885da95d48f8d6f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-aee0-74cf-a7e0-005f46a83dba.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with seating, tables, and outdoor kitchen.",
        "public_id": "01a01007-aee0-74cf-a7e0-005f46a83dba",
        "storage_key": "property/6767906449167585/01a01007-aee0-74cf-a7e0-005f46a83dba.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the outdoors with this spacious covered patio, perfect for gatherings, featuring comfortable seating, dining tables, and a full outdoor kitchen.",
      "link": "false",
      "alt_text": "Outdoor covered patio with seating, tables, and outdoor kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/18-4401 Bunker Hill Rd -5.jpg"
    },
    {
      "id": "ec_061cc5e35c230b0d4073bb07",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-b14c-71c9-90ae-43d91505f833.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with ping pong table, seating, and kitchen area.",
        "public_id": "01a01007-b14c-71c9-90ae-43d91505f833",
        "storage_key": "property/6767906449167585/01a01007-b14c-71c9-90ae-43d91505f833.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the outdoors with our community's covered patio, featuring a ping pong table, comfortable seating, and an outdoor kitchen. Perfect for gatherings.",
      "link": "false",
      "alt_text": "Outdoor covered patio with ping pong table, seating, and kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/19-4401 Bunker Hill Rd -2.jpg"
    },
    {
      "id": "ec_2bece941f9c14822e3a2c5e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-b280-7794-935b-6add7fa9c378.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with couch and tables, overlooking apartment buildings.",
        "public_id": "01a01007-b280-7794-935b-6add7fa9c378",
        "storage_key": "property/6767906449167585/01a01007-b280-7794-935b-6add7fa9c378.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy comfortable outdoor living in this beautifully furnished, covered patio space, perfect for relaxing or socializing with friends while enjoying the view of the surrounding apartment complex.",
      "link": "false",
      "alt_text": "Covered outdoor seating area with couch and tables, overlooking apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/20-4401 Bunker Hill Rd -6.jpg"
    },
    {
      "id": "ec_f773b6fe9189ebf9d862c1a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-b5c3-730a-bc13-ffcc0a007ecc.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a01007-b5c3-730a-bc13-ffcc0a007ecc",
        "storage_key": "property/6767906449167585/01a01007-b5c3-730a-bc13-ffcc0a007ecc.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Ample seating and umbrellas provide comfort and shade for all residents.",
      "link": "false",
      "alt_text": "Resort-style swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13-4401 Bunker Hill Rd -24.jpg"
    },
    {
      "id": "ec_d2e030e160e39a6ab28ce0ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-b7d3-7219-92f4-e850a2491a80.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with seating areas, tables, ping pong table, and outdoor kitchen.",
        "public_id": "01a01007-b7d3-7219-92f4-e850a2491a80",
        "storage_key": "property/6767906449167585/01a01007-b7d3-7219-92f4-e850a2491a80.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this spacious covered patio, featuring comfortable seating, dining tables, a ping pong table, and an outdoor kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Covered outdoor patio with seating areas, tables, ping pong table, and outdoor kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-4401 Bunker Hill Rd -1.jpg"
    },
    {
      "id": "ec_949941530d161558d2eb1bac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-b8a3-765d-9562-191e30fec42e.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with a built-in grill, sink, and two refrigerators.",
        "public_id": "01a01007-b8a3-765d-9562-191e30fec42e",
        "storage_key": "property/6767906449167585/01a01007-b8a3-765d-9562-191e30fec42e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining at our community's outdoor kitchen, complete with a premium grill, sink, and refrigerators.",
      "link": "false",
      "alt_text": "Outdoor kitchen with a built-in grill, sink, and two refrigerators.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/17-4401 Bunker Hill Rd -4.jpg"
    },
    {
      "id": "ec_c7b4fac418c55a3c0249060c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-bb76-71a9-9a9f-704d4f14a71a.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio with ping pong table and foosball table with apartment buildings in the background.",
        "public_id": "01a01007-bb76-71a9-9a9f-704d4f14a71a",
        "storage_key": "property/6767906449167585/01a01007-bb76-71a9-9a9f-704d4f14a71a.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy fun and games on our covered outdoor patio, complete with a ping pong table and foosball table. Perfect for unwinding after a long day or entertaining guests.",
      "link": "false",
      "alt_text": "Covered outdoor patio with ping pong table and foosball table with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/22-4401 Bunker Hill Rd -8.jpg"
    },
    {
      "id": "ec_026b8eae7fa98e0902c15226",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-bcac-75cb-a237-0de3b0b7f74c.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with seating and tables overlooking a large swimming pool and apartment buildings.",
        "public_id": "01a01007-bcac-75cb-a237-0de3b0b7f74c",
        "storage_key": "property/6767906449167585/01a01007-bcac-75cb-a237-0de3b0b7f74c.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our resort-style pool area, featuring comfortable seating, shaded lounges, and an outdoor kitchen perfect for entertaining.",
      "link": "false",
      "alt_text": "Covered outdoor lounge area with seating and tables overlooking a large swimming pool and apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/21-4401 Bunker Hill Rd -7.jpg"
    },
    {
      "id": "ec_a600f1703bee31448208f480",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-c1eb-72a5-a7f0-20083ea9f671.webp",
      "image_media": {
        "alt_text": "Outdoor entertainment area with cornhole, grills, and seating.",
        "public_id": "01a01007-c1eb-72a5-a7f0-20083ea9f671",
        "storage_key": "property/6767906449167585/01a01007-c1eb-72a5-a7f0-20083ea9f671.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community's entertainment area, featuring cornhole, grills, and ample seating for gatherings.",
      "link": "false",
      "alt_text": "Outdoor entertainment area with cornhole, grills, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/23-4401 Bunker Hill Rd -9.jpg"
    },
    {
      "id": "ec_33b4f525c8198ca4d017de98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-c10d-762e-ac45-e58fffe9315e.webp",
      "image_media": {
        "alt_text": "Outdoor communal area with a pool, lounge chairs, BBQ grills, foosball table, and cornhole game.",
        "public_id": "01a01007-c10d-762e-ac45-e58fffe9315e",
        "storage_key": "property/6767906449167585/01a01007-c10d-762e-ac45-e58fffe9315e.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our outdoor amenities including a sparkling pool, comfortable lounge areas, grilling stations, and fun games like foosball and cornhole.",
      "link": "false",
      "alt_text": "Outdoor communal area with a pool, lounge chairs, BBQ grills, foosball table, and cornhole game.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/24-4401 Bunker Hill Rd -10.jpg"
    },
    {
      "id": "ec_b6b514e63ee3103068e3d9f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-c404-704b-9142-500876c6a4f9.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with covered pavilion, cornhole, and string lights.",
        "public_id": "01a01007-c404-704b-9142-500876c6a4f9",
        "storage_key": "property/6767906449167585/01a01007-c404-704b-9142-500876c6a4f9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor lounge area, complete with comfortable seating, a covered pavilion for shade, and fun games like cornhole.",
      "link": "false",
      "alt_text": "Outdoor seating area with covered pavilion, cornhole, and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/25-4401 Bunker Hill Rd -11.jpg"
    },
    {
      "id": "ec_6904780bd8609f89eef16647",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-c619-7488-a0f1-43d5fb52f6e6.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
        "public_id": "01a01007-c619-7488-a0f1-43d5fb52f6e6",
        "storage_key": "property/6767906449167585/01a01007-c619-7488-a0f1-43d5fb52f6e6.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate comfort. Enjoy a refreshing dip or soak up the sun in this beautiful community amenity.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/28-4401 Bunker Hill Rd -27.jpg"
    },
    {
      "id": "ec_afd26b1605220322021c2c6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-c6cb-70f4-99e0-0e8b7d253dea.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a01007-c6cb-70f4-99e0-0e8b7d253dea",
        "storage_key": "property/6767906449167585/01a01007-c6cb-70f4-99e0-0e8b7d253dea.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor pool, surrounded by comfortable lounge seating and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/26-4401 Bunker Hill Rd -25.jpg"
    },
    {
      "id": "ec_2873f6297de551a54f8cf1e3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-ca69-7771-b603-8393d44500c7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a cabana at a modern apartment complex.",
        "public_id": "01a01007-ca69-7771-b603-8393d44500c7",
        "storage_key": "property/6767906449167585/01a01007-ca69-7771-b603-8393d44500c7.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoor swimming pool, complete with comfortable lounge chairs and a covered cabana area, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and a cabana at a modern apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/27-4401 Bunker Hill Rd -26.jpg"
    },
    {
      "id": "ec_e40ef9dde6fc4fad1db5bc67",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-cb15-75d5-abb5-156da3f02798.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge chairs at a multifamily property.",
        "public_id": "01a01007-cb15-75d5-abb5-156da3f02798",
        "storage_key": "property/6767906449167585/01a01007-cb15-75d5-abb5-156da3f02798.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. A perfect oasis for residents.",
      "link": "false",
      "alt_text": "Aerial view of a swimming pool and lounge chairs at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/33-4401 Bunker Hill Rd -32.jpg"
    },
    {
      "id": "ec_22c64192db0bd526f224e766",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-ce6a-7730-9bbe-60d53953f77b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "01a01007-ce6a-7730-9bbe-60d53953f77b",
        "storage_key": "property/6767906449167585/01a01007-ce6a-7730-9bbe-60d53953f77b.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. The perfect place to unwind and soak up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/31-4401 Bunker Hill Rd -30.jpg"
    },
    {
      "id": "ec_91d498c68fc3608c61688c40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-d062-7698-9e93-775600c39d62.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at a multifamily property.",
        "public_id": "01a01007-d062-7698-9e93-775600c39d62",
        "storage_key": "property/6767906449167585/01a01007-d062-7698-9e93-775600c39d62.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and refreshing misters. Enjoy the resort-style amenities at our community.",
      "link": "false",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/32-4401 Bunker Hill Rd -31.jpg"
    },
    {
      "id": "ec_cabf2cfe2b2636e7740726e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-d07d-77ff-8bba-5b4056c689a9.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "01a01007-d07d-77ff-8bba-5b4056c689a9",
        "storage_key": "property/6767906449167585/01a01007-d07d-77ff-8bba-5b4056c689a9.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. Located adjacent to our beautiful apartment buildings.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/45-4401 Bunker Hill Rd -45.jpg"
    },
    {
      "id": "ec_c1f94e2638574dfebac16a21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-d1c2-76bd-bbd0-82b1b04bceab.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas, adjacent to a modern apartment building.",
        "public_id": "01a01007-d1c2-76bd-bbd0-82b1b04bceab",
        "storage_key": "property/6767906449167585/01a01007-d1c2-76bd-bbd0-82b1b04bceab.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, complete with comfortable lounge seating and shaded areas. Perfect for soaking up the sun or enjoying a refreshing dip.",
      "link": "false",
      "alt_text": "Luxurious swimming pool with lounge chairs and umbrellas, adjacent to a modern apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/29-4401 Bunker Hill Rd -28.jpg"
    },
    {
      "id": "ec_de49131bb4e37603ebaab4c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-d41d-72b9-80a4-6a810458367f.webp",
      "image_media": {
        "alt_text": "Balcony with seating and a table overlooking a river and green landscape.",
        "public_id": "01a01007-d41d-72b9-80a4-6a810458367f",
        "storage_key": "property/6767906449167585/01a01007-d41d-72b9-80a4-6a810458367f.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Enjoy the serene views from your private balcony, complete with comfortable seating and a charming table, perfect for morning coffee or evening relaxation.",
      "link": "false",
      "alt_text": "Balcony with seating and a table overlooking a river and green landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/35-4401 Bunker Hill Rd -34.jpg"
    },
    {
      "id": "ec_89f79f9a8fafd775b312fc63",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-d7bc-729c-803b-293db1e565cc.webp",
      "image_media": {
        "alt_text": "Balconies overlooking a lake with fountains and a walking path.",
        "public_id": "01a01007-d7bc-729c-803b-293db1e565cc",
        "storage_key": "property/6767906449167585/01a01007-d7bc-729c-803b-293db1e565cc.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy beautiful lake views and a serene atmosphere from your private balcony.",
      "link": "false",
      "alt_text": "Balconies overlooking a lake with fountains and a walking path.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-4401 Bunker Hill Rd -33.jpg"
    },
    {
      "id": "ec_4448a2797577aef81ee4d1be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-daaa-7210-8183-f331846277f8.webp",
      "image_media": {
        "alt_text": "Balcony with view of a tranquil body of water and lush green landscape.",
        "public_id": "01a01007-daaa-7210-8183-f331846277f8",
        "storage_key": "property/6767906449167585/01a01007-daaa-7210-8183-f331846277f8.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy serene waterfront views from your private balcony, perfect for relaxation and taking in the natural beauty.",
      "link": "false",
      "alt_text": "Balcony with view of a tranquil body of water and lush green landscape.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/37-4401 Bunker Hill Rd -36.jpg"
    },
    {
      "id": "ec_e17789219ab10abef7f0b62d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-dbee-71dc-9843-2fcddb5d1d03.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and fire pits in front of apartment buildings.",
        "public_id": "01a01007-dbee-71dc-9843-2fcddb5d1d03",
        "storage_key": "property/6767906449167585/01a01007-dbee-71dc-9843-2fcddb5d1d03.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax in the outdoor seating area with comfortable chairs and fire pits, perfect for enjoying the evening air and the beautiful apartment community.",
      "link": "false",
      "alt_text": "Outdoor seating area with chairs and fire pits in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/41-4401 Bunker Hill Rd -40.jpg"
    },
    {
      "id": "ec_0607eb519214774de0e5329b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-dc8d-721f-9f7a-f2ded1f6b3b4.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and water view next to apartment building.",
        "public_id": "01a01007-dc8d-721f-9f7a-f2ded1f6b3b4",
        "storage_key": "property/6767906449167585/01a01007-dc8d-721f-9f7a-f2ded1f6b3b4.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, featuring comfortable chairs, a fire pit, and a scenic water view, perfect for enjoying the fresh air and beautiful surroundings.",
      "link": "false",
      "alt_text": "Outdoor seating area with fire pit and water view next to apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/42-4401 Bunker Hill Rd -41.jpg"
    },
    {
      "id": "ec_2a6e7a5aba7af8dab528af6a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-ddce-708d-853f-8abe3b715f72.webp",
      "image_media": {
        "alt_text": "Modern apartment gym with treadmills, weight machines, and benches.",
        "public_id": "01a01007-ddce-708d-853f-8abe3b715f72",
        "storage_key": "property/6767906449167585/01a01007-ddce-708d-853f-8abe3b715f72.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio and strength training equipment for residents.",
      "link": "false",
      "alt_text": "Modern apartment gym with treadmills, weight machines, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/46-4401 Bunker Hill Rd -44.jpg"
    },
    {
      "id": "ec_0c4faccb171c5d788ab8c08d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e07d-711f-b887-1d5b508cc713.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station and seating area overlooking a pond.",
        "public_id": "01a01007-e07d-711f-b887-1d5b508cc713",
        "storage_key": "property/6767906449167585/01a01007-e07d-711f-b887-1d5b508cc713.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation with our community grilling station and comfortable seating, set against a scenic pond view.",
      "link": "false",
      "alt_text": "Outdoor grilling station and seating area overlooking a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/43-4401 Bunker Hill Rd -42.jpg"
    },
    {
      "id": "ec_cdb49f38f81d0f77f8982800",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e5b6-71ca-97b9-badd217d1e30.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with seating, fire pit, and grilling station.",
        "public_id": "01a01007-e5b6-71ca-97b9-badd217d1e30",
        "storage_key": "property/6767906449167585/01a01007-e5b6-71ca-97b9-badd217d1e30.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor courtyard, complete with comfortable seating, a fire pit for cozy evenings, and a BBQ grill for convenient outdoor cooking.",
      "link": "false",
      "alt_text": "Apartment complex courtyard with seating, fire pit, and grilling station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/44-4401 Bunker Hill Rd -43.jpg"
    },
    {
      "id": "ec_c79287e577730923444721f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e5a1-733d-aa3d-e752d90aef42.webp",
      "image_media": {
        "alt_text": "A spacious and modern gym with cardio machines, weight machines, and free weights.",
        "public_id": "01a01007-e5a1-733d-aa3d-e752d90aef42",
        "storage_key": "property/6767906449167585/01a01007-e5a1-733d-aa3d-e752d90aef42.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features a wide array of cardio and strength training equipment to help you achieve your wellness goals.",
      "link": "false",
      "alt_text": "A spacious and modern gym with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/47-4401 Bunker Hill Rd -46.jpg"
    },
    {
      "id": "ec_586f22c2fe9d0617e038fc13",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e675-747d-891b-9f0cc07a342d.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and stair climber in a modern gym with a pool view.",
        "public_id": "01a01007-e675-747d-891b-9f0cc07a342d",
        "storage_key": "property/6767906449167585/01a01007-e675-747d-891b-9f0cc07a342d.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio machines and stunning views of the resort-style pool.",
      "link": "false",
      "alt_text": "Treadmills, ellipticals, and stair climber in a modern gym with a pool view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/48-4401 Bunker Hill Rd -48.jpg"
    },
    {
      "id": "ec_d5f232891fcfaad867c8f98b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e73a-775e-8a52-45b291ac8d44.webp",
      "image_media": {
        "alt_text": "Modern, well-lit hallway with elevator and exit doors.",
        "public_id": "01a01007-e73a-775e-8a52-45b291ac8d44",
        "storage_key": "property/6767906449167585/01a01007-e73a-775e-8a52-45b291ac8d44.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Step into our modern and well-lit hallways, featuring a convenient elevator and easy access to exits, creating a welcoming environment for residents.",
      "link": "false",
      "alt_text": "Modern, well-lit hallway with elevator and exit doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/49-4401 Bunker Hill Rd -49.jpg"
    },
    {
      "id": "ec_461bd7ea51778aa952fc55a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-e9e3-73ad-b157-d18557b8a70c.webp",
      "image_media": {
        "alt_text": "Attached garage with automatic opener and white car.",
        "public_id": "01a01007-e9e3-73ad-b157-d18557b8a70c",
        "storage_key": "property/6767906449167585/01a01007-e9e3-73ad-b157-d18557b8a70c.webp",
        "width": 800,
        "height": 600
      },
      "title": "Apartment",
      "description": "Convenient attached garage with automatic door opener and space for your vehicle. Additional storage shelving included.",
      "link": "false",
      "alt_text": "Attached garage with automatic opener and white car.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/52-4401 Bunker Hill Rd -52.jpg"
    },
    {
      "id": "ec_299148136f9dfc6267198c31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/01a01007-f00a-76a9-ac21-f0d9ad318194.webp",
      "image_media": {
        "alt_text": "Interior of a clean garage with a white Audi station wagon parked inside.",
        "public_id": "01a01007-f00a-76a9-ac21-f0d9ad318194",
        "storage_key": "property/6767906449167585/01a01007-f00a-76a9-ac21-f0d9ad318194.webp",
        "width": 800,
        "height": 600
      },
      "title": "Community",
      "description": "Secure your vehicle in our spacious, clean garages, offering convenient and protected parking.",
      "link": "false",
      "alt_text": "Interior of a clean garage with a white Audi station wagon parked inside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/51-4401 Bunker Hill Rd -51.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_da0ced86-295d-43c2-a300-3101e0036a85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Ferah Tex-Med Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "690 Beebalm Ln, Garland, TX 75040, USA",
      "poi_short_description": "Friendly spot for Texas spin on Mediterranean favorites, including gyro quesadillas & falafel tacos.",
      "poi_long_description": "Friendly spot for Texas spin on Mediterranean favorites, including gyro quesadillas & falafel tacos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5655-740f-ae1d-9a5089f543a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5655-740f-ae1d-9a5089f543a8",
        "storage_key": "property/6767906449167585/019fc920-5655-740f-ae1d-9a5089f543a8.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.ferahtexmed.com/garland",
      "poi_directions_map_url": "https://maps.google.com/?cid=613611853933511052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ferah-tex-med-kitchen",
      "poi_latitude": "32.954053",
      "poi_longitude": "-96.6108406",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-256-8971",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9zkyryMdTIYRjAGt57r8gwg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_ff8cac87-07d7-41c1-bd99-5c0d4e6da08c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Herb & Ember",
      "poi_type": "Restaurants",
      "poi_address": "365 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-49b8-731f-b2c2-a01259654375.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-49b8-731f-b2c2-a01259654375",
        "storage_key": "property/6767906449167585/019fc920-49b8-731f-b2c2-a01259654375.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "http://www.theherbandember.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7729122119354176246&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "herb--ember",
      "poi_latitude": "32.9521868",
      "poi_longitude": "-96.6130276",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-256-8991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4FjPD4dTIYR9lK47Z1bQ2s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_99236536-11dd-4386-84ce-d45f9705f135",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Gloria's Latin Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "360 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_long_description": "Family-friendly chain featuring Salvadoran & Tex-Mex favorites, plus mojitos & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-47bb-73fd-9315-d3e71b22d9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-47bb-73fd-9315-d3e71b22d9b5",
        "storage_key": "property/6767906449167585/019fc920-47bb-73fd-9315-d3e71b22d9b5.webp",
        "width": 648,
        "height": 432
      },
      "poi_business_url": "https://gloriascuisine.com/locations/garland.html?utm_source=google&utm_medium=Yext&y_source=1_MjA1ODAzNTItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3871909501019319829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glorias-latin-cuisine",
      "poi_latitude": "32.95193709999999",
      "poi_longitude": "-96.6126451",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-526-5290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf2iT-_wcTIYRFW63Si3JuzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7bb879ce-e672-4b3c-b6a5-c1534f085d78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Wildwood Firewheel",
      "poi_type": "Restaurants",
      "poi_address": "310 Town Center Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Easygoing eatery featuring southern comfort food, happy hour & weekend brunch, plus delivery.",
      "poi_long_description": "Easygoing eatery featuring southern comfort food, happy hour & weekend brunch, plus delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-49ab-7070-879e-9678aaeadf19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-49ab-7070-879e-9678aaeadf19",
        "storage_key": "property/6767906449167585/019fc920-49ab-7070-879e-9678aaeadf19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wildwoodtx.com/firehweel",
      "poi_directions_map_url": "https://maps.google.com/?cid=16401386762637158791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildwood-firewheel",
      "poi_latitude": "32.9530196",
      "poi_longitude": "-96.6148916",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-496-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3254PvwcTIYRhynIwlxuneM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9bc21bab-004d-46e1-ade0-dd6590c998fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Palio's Pizza Cafe At Firewheel",
      "poi_type": "Restaurants",
      "poi_address": "615 Town Square Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Kid-friendly chain outpost presenting thin-crust pizza & pasta dishes in a comfy, BYOB setup.",
      "poi_long_description": "Kid-friendly chain outpost presenting thin-crust pizza & pasta dishes in a comfy, BYOB setup.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-46fa-7655-b425-871fe79e4597.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-46fa-7655-b425-871fe79e4597",
        "storage_key": "property/6767906449167585/019fc920-46fa-7655-b425-871fe79e4597.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://paliospizzagarland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17306596772493413186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palios-pizza-cafe-at-firewheel",
      "poi_latitude": "32.954063",
      "poi_longitude": "-96.6119715",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-409-2935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJnTc7bqMdTIYRQktk_xFiLfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_41328ec2-5829-4822-9be5-0d6030c00cc4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Razzoo's Cajun Cafe",
      "poi_type": "Restaurants",
      "poi_address": "310 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Local chain with New Orleans flavor serving bayou-inspired fare in a festive setting.",
      "poi_long_description": "Local chain with New Orleans flavor serving bayou-inspired fare in a festive setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-611a-7631-9309-c11dba932829.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-611a-7631-9309-c11dba932829",
        "storage_key": "property/6767906449167585/019ff6cd-611a-7631-9309-c11dba932829.webp",
        "width": 340,
        "height": 512
      },
      "poi_business_url": "http://www.razzoos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16737040701628684141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "razzoos-cajun-cafe",
      "poi_latitude": "32.9514793",
      "poi_longitude": "-96.6129235",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-427-8215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxq2AP0cTIYRbRfVa9fpReg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_f9eeb498-636d-4db4-bf35-da7c790010ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Laughing Crab Cajun Seafood",
      "poi_type": "Restaurants",
      "poi_address": "340 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Down-to-earth eatery dispensing all-you-can-eat seafood dishes like snow crab.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5110-7388-b67e-7eee755d62f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5110-7388-b67e-7eee755d62f2",
        "storage_key": "property/6767906449167585/019fc920-5110-7388-b67e-7eee755d62f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.laughingcrabgarlandtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11680078159820559153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laughing-crab-cajun-seafood",
      "poi_latitude": "32.9517663",
      "poi_longitude": "-96.6126937",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-496-6788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bu2SPgdTIYRMRPn4DP5F6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_754ace3e-ca68-4eec-895c-b08a1f494b0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Beeso Coffee at Firewheel",
      "poi_type": "Restaurants",
      "poi_address": "337 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-4cda-75f0-9959-ae5e0caeaffa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-4cda-75f0-9959-ae5e0caeaffa",
        "storage_key": "property/6767906449167585/019fc920-4cda-75f0-9959-ae5e0caeaffa.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://beesocoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11722964738801658444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beeso-coffee-at-firewheel",
      "poi_latitude": "32.9519151",
      "poi_longitude": "-96.6131945",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-495-2539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c086-701e-bbe9-fb828c59fd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c086-701e-bbe9-fb828c59fd7e",
        "storage_key": "property/6767906449167585/019fc920-c086-701e-bbe9-fb828c59fd7e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJZbZ2oakdTIYRTOqzqlFWsKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_2c658978-f99a-402c-a7fd-11bda92b10a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Eddie's Napolis Italian Bistro",
      "poi_type": "Restaurants",
      "poi_address": "4280 Lavon Dr #250, Garland, TX 75040, USA",
      "poi_short_description": "Laid-back fixture serving a variety of Italian classics, including pasta & pizza.",
      "poi_long_description": "Laid-back fixture serving a variety of Italian classics, including pasta & pizza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-69bd-70f2-b0cf-cc7c988e75d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-69bd-70f2-b0cf-cc7c988e75d6",
        "storage_key": "property/6767906449167585/019ff6cd-69bd-70f2-b0cf-cc7c988e75d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eddiesnapolis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7404652025945378123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eddies-napolis-italian-bistro",
      "poi_latitude": "32.956481",
      "poi_longitude": "-96.615917",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-530-2004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCUv2aPkcTIYRS83ZO8mbwmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_bca8da2e-7a2a-46ea-8343-2d32c1107e97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Scotty P's",
      "poi_type": "Restaurants",
      "poi_address": "4280 Lavon Dr #200, Garland, TX 75040, USA",
      "poi_short_description": "Family-owned spot turning out flame-grilled burgers plus chicken dishes and salads.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-633d-77dd-9277-95264696bce2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-633d-77dd-9277-95264696bce2",
        "storage_key": "property/6767906449167585/019ff6cd-633d-77dd-9277-95264696bce2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://scottyps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5341631296193404151&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scotty-ps",
      "poi_latitude": "32.9559467",
      "poi_longitude": "-96.6165916",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-495-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhZ2vLfkcTIYR95y32lxJIUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_66687d50-dcc3-43fe-bdbc-e7c19ec72a0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5012 N President George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-44c4-70b0-935f-263a7a166831.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-44c4-70b0-935f-263a7a166831",
        "storage_key": "property/6767906449167585/019fc91c-44c4-70b0-935f-263a7a166831.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/garland?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=16738526719177846910&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.96322019999999",
      "poi_longitude": "-96.6367052",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-495-0417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7MjJkQcTIYRfvD6110xS-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_088d69af-fd16-4085-8e57-b3da654f564e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Lazy Dog Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5180 N President George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_long_description": "Relaxed, lodge-chic chain serving global comfort fare, including stir-fries, pot roast & pastas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-4409-76aa-9df6-81a081ec3715.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-4409-76aa-9df6-81a081ec3715",
        "storage_key": "property/6767906449167585/019fc91c-4409-76aa-9df6-81a081ec3715.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lazydogrestaurants.com/pages/garland-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=9999715939121403096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lazy-dog-restaurant--bar",
      "poi_latitude": "32.9649559",
      "poi_longitude": "-96.6387518",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 945-207-7552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4awlDwAdTIYR2JQkdqogxoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_29bb28df-28b2-4807-8e36-9d437080722c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Rosalind Coffee",
      "poi_type": "Restaurants",
      "poi_address": "107 N 6th St, Garland, TX 75040, USA",
      "poi_short_description": "This indie java joint offers fair-trade coffee with sweets made on-site & music on the weekends.",
      "poi_long_description": "This indie java joint offers fair-trade coffee with sweets made on-site & music on the weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-62d9-7510-a27f-0249c163e0b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-62d9-7510-a27f-0249c163e0b9",
        "storage_key": "property/6767906449167585/019ff6cd-62d9-7510-a27f-0249c163e0b9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://rosalindcoffeetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5552107178543935183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosalind-coffee",
      "poi_latitude": "32.9129916",
      "poi_longitude": "-96.6379619",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-494-9449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c086-701e-bbe9-fb828c59fd7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c086-701e-bbe9-fb828c59fd7e",
        "storage_key": "property/6767906449167585/019fc920-c086-701e-bbe9-fb828c59fd7e.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJc6xY6Y0dTIYRz-4BBBAMDU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7cfa7097-100a-4e56-bb00-bc849716408e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Fortunate Son",
      "poi_type": "Restaurants",
      "poi_address": "500 Main St Ste 100, Garland, TX 75040, USA",
      "poi_short_description": "Casual joint serving wood-fired pizzas and Italian fare such as chicken parm in a welcoming atmosphere.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-43fb-71ab-a91c-3b9e6f95cd2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-43fb-71ab-a91c-3b9e6f95cd2b",
        "storage_key": "property/6767906449167585/019fc91c-43fb-71ab-a91c-3b9e6f95cd2b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://fortunatesontx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17912106837166892408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortunate-son",
      "poi_latitude": "32.912502",
      "poi_longitude": "-96.6366311",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfPJCAEdTIYReKUtGESWlPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_d6e42f35-803c-4af4-a9f4-6b8ab8bccb04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "The Catch: Garland",
      "poi_type": "Restaurants",
      "poi_address": "5949 Broadway Blvd, Garland, TX 75043, USA",
      "poi_short_description": "Casual restaurant serving up seafood dishes, including specialties such as the Cajun special and fried catfish.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-6680-70de-913f-ff45b90d2009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-6680-70de-913f-ff45b90d2009",
        "storage_key": "property/6767906449167585/019ff6cd-6680-70de-913f-ff45b90d2009.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thecatchdfw.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=135393447046051027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-catch-garland",
      "poi_latitude": "32.8432481",
      "poi_longitude": "-96.5962639",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 51 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-443-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-820b-7767-8405-070a947f9917",
        "storage_key": "property/6767906449167585/019fc91c-820b-7767-8405-070a947f9917.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TWioYqnToYR03QYbJ8D4QE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_268f23e1-0436-4973-b571-44e6bac7cb8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Tom Thumb",
      "poi_type": "Shopping & Retail",
      "poi_address": "2535 Firewheel Pkwy, Garland, TX 75040, USA",
      "poi_short_description": "Grocery store offering produce, prepared foods, and a bakery, plus a deli, and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-64f1-77c0-8c6b-77f79e6da8e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-64f1-77c0-8c6b-77f79e6da8e4",
        "storage_key": "property/6767906449167585/019ff6cd-64f1-77c0-8c6b-77f79e6da8e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://local.tomthumb.com/tx/garland/2535-firewheel-pkwy.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7513901758864196443&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tom-thumb",
      "poi_latitude": "32.9374184",
      "poi_longitude": "-96.6055191",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-675-8661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8281-7049-92a5-c7ea8f44e425",
        "storage_key": "property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxNVshAdTIYRW4NI3ta9Rmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8ebc9318-f4d6-48c3-b466-b47f5966d57b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Firewheel Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "245 Cedar Sage Dr, Garland, TX 75040, USA",
      "poi_short_description": "Open-air shopping venue offering brand-name department stores & boutiques, eateries & a cinema.",
      "poi_long_description": "Open-air shopping venue offering brand-name department stores & boutiques, eateries & a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-3f15-758e-ae29-a41a59267f63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-3f15-758e-ae29-a41a59267f63",
        "storage_key": "property/6767906449167585/019fc91c-3f15-758e-ae29-a41a59267f63.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "https://www.simon.com/mall/firewheel-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573802943106674088&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firewheel-town-center",
      "poi_latitude": "32.9538707",
      "poi_longitude": "-96.6126318",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-675-1041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8204-76ab-8aeb-a816ce4f3c80",
        "storage_key": "property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfQHcjvwcTIYRqG0-xHRonqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_96b0f7f7-da04-4ad4-8f70-ea2a6cf45304",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "5702 Lavon Dr, Garland, TX 75040, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6e4d-712f-bb5e-f3f21c67e8ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6e4d-712f-bb5e-f3f21c67e8ac",
        "storage_key": "property/6767906449167585/019fc920-6e4d-712f-bb5e-f3f21c67e8ac.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/garland-tx-pharmacies/5702-lavon-dr-garland-tx-75040/storeid=7824?WT.mc_id=LS_GOOGLE_FS_7824",
      "poi_directions_map_url": "https://maps.google.com/?cid=15795101777709335644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "32.9677654",
      "poi_longitude": "-96.6071504",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-495-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ197ETewcTIYRXISBe2F5M9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_62f02207-5111-4d5d-a1f2-1d4219d8445f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 W Buckingham Rd, Garland, TX 75040, USA",
      "poi_short_description": "Chain grocery store offering a variety of products, including produce, plus check cashing, a pharmacy, and a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-679c-773b-86da-fd09bec1c66d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-679c-773b-86da-fd09bec1c66d",
        "storage_key": "property/6767906449167585/019ff6cd-679c-773b-86da-fd09bec1c66d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walmart.com/store/2433-garland-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573168557667191154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "32.9320716",
      "poi_longitude": "-96.6316824",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-304-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8281-7049-92a5-c7ea8f44e425",
        "storage_key": "property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3WJBrKQdTIYRcgkJA0sCH9g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_10bf9026-954e-4e1e-a7bc-b612a8c1e370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1518 W Buckingham Rd, Garland, TX 75042, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-6a0b-74c4-8f14-485fe30d7330.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-6a0b-74c4-8f14-485fe30d7330",
        "storage_key": "property/6767906449167585/019ff6cd-6a0b-74c4-8f14-485fe30d7330.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/tx/garland/1518-buckingham-rd/l810",
      "poi_directions_map_url": "https://maps.google.com/?cid=1026352492596696852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "32.93025",
      "poi_longitude": "-96.6508",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8281-7049-92a5-c7ea8f44e425",
        "storage_key": "property/6767906449167585/019fc91c-8281-7049-92a5-c7ea8f44e425.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WFgfsMdTIYRFBeQdydWPg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_00855f64-f845-4f2a-bb26-69f1f7ecee4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Buckingham Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1413 W Buckingham Rd, Garland, TX 75042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-6a50-717a-9627-1eb02eca8bed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-6a50-717a-9627-1eb02eca8bed",
        "storage_key": "property/6767906449167585/019ff6cd-6a50-717a-9627-1eb02eca8bed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://buckingham-plaza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5792227458144989250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buckingham-plaza",
      "poi_latitude": "32.9313603",
      "poi_longitude": "-96.6499176",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-954-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0qxfcQdTIYRQvD-RC8gYlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_5e9d0b74-f96f-4e16-94bf-fcf61796f3fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "5301 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5d25-71e9-8bc7-0c1ae75baf6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5d25-71e9-8bc7-0c1ae75baf6e",
        "storage_key": "property/6767906449167585/019fc920-5d25-71e9-8bc7-0c1ae75baf6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/garland-east/1489",
      "poi_directions_map_url": "https://maps.google.com/?cid=11781631119895688979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.9654216",
      "poi_longitude": "-96.6465667",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-535-0252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8204-76ab-8aeb-a816ce4f3c80",
        "storage_key": "property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ59_kzTgcTIYRE_cR8BTDgKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_4fbfef7d-f220-4f67-9898-e7c6a5a71dc3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "190 Cedar Sage Dr Unit BB01, Garland, TX 75040, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7027-7408-b0bf-7fff9014104b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7027-7408-b0bf-7fff9014104b",
        "storage_key": "property/6767906449167585/019ff6cd-7027-7408-b0bf-7fff9014104b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2222",
      "poi_directions_map_url": "https://maps.google.com/?cid=13516284002887874892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barnes--noble",
      "poi_latitude": "32.9535268",
      "poi_longitude": "-96.613191",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-496-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8204-76ab-8aeb-a816ce4f3c80",
        "storage_key": "property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5su6_wcTIYRTDltM7B8k7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_1d34f395-f25c-48d2-8800-5036b0d68365",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "425 Town Center Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_long_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-6d42-7762-a842-54c9bb7dedbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-6d42-7762-a842-54c9bb7dedbd",
        "storage_key": "property/6767906449167585/019ff6cd-6d42-7762-a842-54c9bb7dedbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.fivebelow.com/tx/garland/425-town-center-blvd?utm_source=gmb&utm_medium=yext&y_source=1_MjAzMjEwNDUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13269951690367620690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "32.9526735",
      "poi_longitude": "-96.6130656",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 972-483-4984",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8204-76ab-8aeb-a816ce4f3c80",
        "storage_key": "property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJA1LCINkdTIYRUtb0UsFWKLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_55169fd7-b612-4bc9-b786-9aaa34f3d06d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "1445 W Buckingham Rd, Garland, TX 75042, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-6fc2-751c-bc09-36c479f02348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-6fc2-751c-bc09-36c479f02348",
        "storage_key": "property/6767906449167585/019ff6cd-6fc2-751c-bc09-36c479f02348.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5983693807501441529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "32.9317057",
      "poi_longitude": "-96.6498884",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 469-750-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8204-76ab-8aeb-a816ce4f3c80",
        "storage_key": "property/6767906449167585/019fc91c-8204-76ab-8aeb-a816ce4f3c80.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZ_zj4NAdTIYR-fnToNBZClM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e395ed75-cae1-4731-86c4-0b01505ac9bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Robert B. Sewell Elementary School",
      "poi_type": "Education",
      "poi_address": "4400 Hudson Dr, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5c71-720e-81c7-4016a81bb9e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5c71-720e-81c7-4016a81bb9e2",
        "storage_key": "property/6767906449167585/019fc920-5c71-720e-81c7-4016a81bb9e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandisdschools.net/page.cfm?p=1265",
      "poi_directions_map_url": "https://maps.google.com/?cid=6493512837236998677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-b-sewell-elementary-school",
      "poi_latitude": "32.9572499",
      "poi_longitude": "-96.5816333",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-675-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqyLSLtIcTIYRFULzd4WXHVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c0f5623b-9138-4004-87ea-3ef15d860e24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "John W. Armstrong Elementary School",
      "poi_type": "Education",
      "poi_address": "4750 Ben Davis Rd, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.garlandisdschools.net/armstrong",
      "poi_directions_map_url": "https://maps.google.com/?cid=1389978641658060927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-w-armstrong-elementary-school",
      "poi_latitude": "32.9667295",
      "poi_longitude": "-96.6001141",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 972-414-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7f52AMIcTIYRf6BozTUyShM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_adf85f3a-cef7-4331-a1c1-ba9e5c80f973",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "B. G. Hudson Middle School",
      "poi_type": "Education",
      "poi_address": "4405 Hudson Dr, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5d9c-75fa-a33a-d4a04dd409a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5d9c-75fa-a33a-d4a04dd409a7",
        "storage_key": "property/6767906449167585/019fc920-5d9c-75fa-a33a-d4a04dd409a7.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.garlandisdschools.net/page.cfm?p=593",
      "poi_directions_map_url": "https://maps.google.com/?cid=10816061710094268220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "b-g-hudson-middle-school",
      "poi_latitude": "32.958925",
      "poi_longitude": "-96.5812582",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-675-3070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ZDqbtEcTIYRPHffwtFeGpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_76abfbfb-f278-449d-83df-7480e26ac509",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Sellers Middle School",
      "poi_type": "Education",
      "poi_address": "1009 Mars Dr, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7101-71b9-a9c7-65863a28dfd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7101-71b9-a9c7-65863a28dfd5",
        "storage_key": "property/6767906449167585/019ff6cd-7101-71b9-a9c7-65863a28dfd5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.garlandisdschools.net/sellers",
      "poi_directions_map_url": "https://maps.google.com/?cid=17776144752632374092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sellers-middle-school",
      "poi_latitude": "32.9208166",
      "poi_longitude": "-96.6224539",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-494-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ956IO54dTIYRTKOTcHiNsfY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4864ac6b-e37b-4388-a4e9-7933a5997321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Sachse High School",
      "poi_type": "Education",
      "poi_address": "3901 Miles Rd, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6113-724d-aae3-3db45f8e361c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6113-724d-aae3-3db45f8e361c",
        "storage_key": "property/6767906449167585/019fc920-6113-724d-aae3-3db45f8e361c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandisdschools.net/page.cfm?p=157",
      "poi_directions_map_url": "https://maps.google.com/?cid=8579298755888531871&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sachse-high-school",
      "poi_latitude": "32.961536",
      "poi_longitude": "-96.5848019",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 972-414-7450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJRT548y4dTIYRn8mvbsPKD3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9b65e26a-5d68-4b97-a788-1389b3e56904",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Pinnacle Montessori of Sachse",
      "poi_type": "Education",
      "poi_address": "4225 Miles Rd, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-7757-70be-88c4-302c76e4776c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-7757-70be-88c4-302c76e4776c",
        "storage_key": "property/6767906449167585/019fc920-7757-70be-88c4-302c76e4776c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pinnaclemontessori.com/sachse/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13629298713406235304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-montessori-of-sachse",
      "poi_latitude": "32.9633271",
      "poi_longitude": "-96.5839071",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-842-1104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLSnHbxEdTIYRqGJE_vf-JL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0e9441e6-3dc2-41c3-9bcd-fb7f66ef9009",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Small Miracles Academy Sachse Campus",
      "poi_type": "Education",
      "poi_address": "5545 Brookview Dr, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-74ba-735e-9390-abd9b42fde8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-74ba-735e-9390-abd9b42fde8b",
        "storage_key": "property/6767906449167585/019ff6cd-74ba-735e-9390-abd9b42fde8b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.smallmiraclesacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15170037077418531978&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "small-miracles-academy-sachse-campus",
      "poi_latitude": "32.9738314",
      "poi_longitude": "-96.5980233",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 469-969-2114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmwRAlr8cTIYRilwJ_VjMhtI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_4f62d637-fa16-46a2-8d55-fd28e9614734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "The Learning Experience - Sachse",
      "poi_type": "Education",
      "poi_address": "7950 S State Hwy 78, Sachse, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-5ff0-74ad-b1fe-3f1565207c10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-5ff0-74ad-b1fe-3f1565207c10",
        "storage_key": "property/6767906449167585/019fc920-5ff0-74ad-b1fe-3f1565207c10.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://thelearningexperience.com/centers/sachse/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3942979037524871019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-learning-experience---sachse",
      "poi_latitude": "32.9918054",
      "poi_longitude": "-96.5687215",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 469-304-0173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJc6uceZIDTIYRa0d7OItGuDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_e3e397fc-f193-49e1-8e0a-ea52164f24fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Firewheel Christian Academy",
      "poi_type": "Education",
      "poi_address": "5500 Lavon Dr, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7233-73a8-ba94-9e4c9589407f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7233-73a8-ba94-9e4c9589407f",
        "storage_key": "property/6767906449167585/019ff6cd-7233-73a8-ba94-9e4c9589407f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://firewheelca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8184548425610951429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firewheel-christian-academy",
      "poi_latitude": "32.9662065",
      "poi_longitude": "-96.6085",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 972-495-0851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv219we0cTIYRBfuF821blXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_62acedc0-292b-4945-b4ee-7a3d5337771c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Collin College - Spring Creek Campus",
      "poi_type": "Education",
      "poi_address": "2800 E Spring Creek Pkwy, Plano, TX 75074, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7364-7764-9fc3-a56c63ae7067.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7364-7764-9fc3-a56c63ae7067",
        "storage_key": "property/6767906449167585/019ff6cd-7364-7764-9fc3-a56c63ae7067.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.collin.edu/campuses/plano/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3446531868695229876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collin-college---spring-creek-campus",
      "poi_latitude": "33.0505361",
      "poi_longitude": "-96.6770028",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-881-5790",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM3W0opEZTIYRtHWkXHmK1C8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7c180c81-6c87-43ef-81b5-d41c4f580959",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "AMC Firewheel 18",
      "poi_type": "Entertainment",
      "poi_address": "100 Coneflower Dr, Garland, TX 75040, USA",
      "poi_short_description": "Chain movie theater in Firewheel Town Center with IMAX, Dolby Cinema, and Dine-In options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-644c-730b-8596-a03cd9e466af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-644c-730b-8596-a03cd9e466af",
        "storage_key": "property/6767906449167585/019fc920-644c-730b-8596-a03cd9e466af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/dallas-ft-worth/amc-firewheel-18?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1082600335928098491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-firewheel-18",
      "poi_latitude": "32.9506591",
      "poi_longitude": "-96.61410010000002",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-530-2262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c07c-77b0-afda-e9084242db14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c07c-77b0-afda-e9084242db14",
        "storage_key": "property/6767906449167585/019fc920-c07c-77b0-afda-e9084242db14.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62xFo_0cTIYRu362CEUrBg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9b521103-f6c7-46d8-89bc-f230cb0c4954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Hawaiian Waters Garland",
      "poi_type": "Entertainment",
      "poi_address": "4550 N Garland Ave, Garland, TX 75040, USA",
      "poi_short_description": "Branch of a chain of water parks with slides, rides, lazy river & a 16,000-sq.-ft. wave pool.",
      "poi_long_description": "Branch of a chain of water parks with slides, rides, lazy river & a 16,000-sq.-ft. wave pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-4af7-74bd-9410-ea528fae35fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-4af7-74bd-9410-ea528fae35fd",
        "storage_key": "property/6767906449167585/019fc91c-4af7-74bd-9410-ea528fae35fd.webp",
        "width": 680,
        "height": 451
      },
      "poi_business_url": "http://www.hawaiianwaters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11586946791377660959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawaiian-waters-garland",
      "poi_latitude": "32.9565022",
      "poi_longitude": "-96.650861",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-905-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R2tEzAcTIYRH-xqa7cazaA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_fe746dd1-297d-404f-a02d-13db98a169c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Granville Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "300 N 5th St, Garland, TX 75040, USA",
      "poi_short_description": "Arts complex with 2 auditoriums & other spaces hosting concerts & theatrical productions.",
      "poi_long_description": "Arts complex with 2 auditoriums & other spaces hosting concerts & theatrical productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-651c-70ec-af77-50c399bd317a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-651c-70ec-af77-50c399bd317a",
        "storage_key": "property/6767906449167585/019fc920-651c-70ec-af77-50c399bd317a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garlandarts.com/4060/Arts",
      "poi_directions_map_url": "https://maps.google.com/?cid=18291813425782077565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granville-arts-center",
      "poi_latitude": "32.9149998",
      "poi_longitude": "-96.6359915",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-205-2780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_tdzpEdTIYRfTh2hWWT2f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_6a749d41-62ca-4b36-af1d-493cee68b826",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Plaza Theater",
      "poi_type": "Entertainment",
      "poi_address": "521 W State St, Garland, TX 75040, USA",
      "poi_short_description": "Arts complex with variety of theater spaces for everything from Broadway shows to symphony concerts.",
      "poi_long_description": "Arts complex with variety of theater spaces for everything from Broadway shows to symphony concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6ab0-720e-a942-6338e1b6e6b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6ab0-720e-a942-6338e1b6e6b9",
        "storage_key": "property/6767906449167585/019fc920-6ab0-720e-a942-6338e1b6e6b9.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://garlandarts.com/3196/Plaza-Theatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=13268994195775793873&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "plaza-theater",
      "poi_latitude": "32.9134724",
      "poi_longitude": "-96.6376145",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-205-2785",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgd015Y0dTIYR0arvPevvJLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_e21cb4a4-ff4b-43fe-93cd-b6e678a6bcf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Curtis Culwell Center",
      "poi_type": "Entertainment",
      "poi_address": "4999 Naaman Forest Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Modern arena & conference center hosting talks, concerts, sports, performances & other events.",
      "poi_long_description": "Modern arena & conference center hosting talks, concerts, sports, performances & other events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-5c20-72cb-aecc-a5992f5eb30a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-5c20-72cb-aecc-a5992f5eb30a",
        "storage_key": "property/6767906449167585/019fc91c-5c20-72cb-aecc-a5992f5eb30a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.curtisculwellcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3166940037103987712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtis-culwell-center",
      "poi_latitude": "32.9593076",
      "poi_longitude": "-96.641932",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-487-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjwBz404cTIYRAKyLQC878ys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_798303b1-39b7-48d2-81ba-ef32782e16a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Firewheel Golf Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 W Campbell Rd, Garland, TX 75044, USA",
      "poi_short_description": "Spacious complex featuring 3 separate golf courses as well as a driving range, restaurant & patio.",
      "poi_long_description": "Spacious complex featuring 3 separate golf courses as well as a driving range, restaurant & patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6c69-72c9-82b2-5cc696488bdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6c69-72c9-82b2-5cc696488bdf",
        "storage_key": "property/6767906449167585/019fc920-6c69-72c9-82b2-5cc696488bdf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.golffirewheel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15148042254782820331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firewheel-golf-park",
      "poi_latitude": "32.9769026",
      "poi_longitude": "-96.6348068",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-205-2795",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-827d-77a2-9c8b-5fb0492d80f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-827d-77a2-9c8b-5fb0492d80f3",
        "storage_key": "property/6767906449167585/019fc91c-827d-77a2-9c8b-5fb0492d80f3.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJn2IEfm8cTIYR6-_vRiyoONI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_553b387a-b0e3-4e9a-9008-beee8d01cc59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Lucky Strike Garland",
      "poi_type": "Entertainment",
      "poi_address": "1950 Marketplace Dr, Garland, TX 75041, USA",
      "poi_short_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_long_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-75d7-769f-af73-d944e65226e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-75d7-769f-af73-d944e65226e2",
        "storage_key": "property/6767906449167585/019ff6cd-75d7-769f-af73-d944e65226e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-garland?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=12501230388601058916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-garland",
      "poi_latitude": "32.8629245",
      "poi_longitude": "-96.6544196",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 972-613-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ98f_ySinToYRZHbi181Kfa0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_02de3929-5c31-4584-8e32-c97604d68bfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Garland Landmark Museum",
      "poi_type": "Entertainment",
      "poi_address": "393 N 6th St, Garland, TX 75040, USA",
      "poi_short_description": "Quaint museum in a historic Santa Fe railway depot dedicated to local history & cultural heritage.",
      "poi_long_description": "Quaint museum in a historic Santa Fe railway depot dedicated to local history & cultural heritage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6399-712d-8bd6-863b93623a29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6399-712d-8bd6-863b93623a29",
        "storage_key": "property/6767906449167585/019fc920-6399-712d-8bd6-863b93623a29.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://garlandheritage.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5403242124340948571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-landmark-museum",
      "poi_latitude": "32.915575",
      "poi_longitude": "-96.6381151",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-205-2996",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c075-748b-b854-8000a11f72d6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c075-748b-b854-8000a11f72d6",
        "storage_key": "property/6767906449167585/019fc920-c075-748b-b854-8000a11f72d6.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTVxtPpIdTIYRW-7EoBUs_Eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_170f44ee-bbeb-4ca2-892d-7af2100f898b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Kids Empire Dallas Firewheel",
      "poi_type": "Entertainment",
      "poi_address": "550 Town Center Blvd, Garland, TX 75040, USA",
      "poi_short_description": "Varying slides and a ball pit are among the attractions at this super clean indoor playground, plus party rooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7694-7228-86b8-8333bd70be6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7694-7228-86b8-8333bd70be6a",
        "storage_key": "property/6767906449167585/019ff6cd-7694-7228-86b8-8333bd70be6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kidsempire.com/park/firewheel?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=13444660129735175447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kids-empire-dallas-firewheel",
      "poi_latitude": "32.9516321",
      "poi_longitude": "-96.6120424",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-961-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNwCJvLQdTIYRF-24ticHlbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indoor_playground"
    },
    {
      "id": "custom_cd0715fb-9bae-4d0a-84a1-762dcd81ff70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Medical City ER Garland",
      "poi_type": "Health and Wellness",
      "poi_address": "3318 W Buckingham Rd, Garland, TX 75042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6b4f-778c-b232-098173c8f06a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6b4f-778c-b232-098173c8f06a",
        "storage_key": "property/6767906449167585/019fc920-6b4f-778c-b232-098173c8f06a.webp",
        "width": 595,
        "height": 334
      },
      "poi_business_url": "https://medicalcityhealthcare.com/locations/medical-city-er-garland/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=16167344223227957848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-city-er-garland",
      "poi_latitude": "32.929937",
      "poi_longitude": "-96.680717",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 469-801-7960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdyNcGV8fTIYRWFL3qunxXeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_65b10f2a-7706-433e-833a-8b045bb0b8cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "TotalCare Emergency Room",
      "poi_type": "Health and Wellness",
      "poi_address": "738 W Centerville Rd, Garland, TX 75041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-780a-74a0-8fe5-bdf5f9d1a184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-780a-74a0-8fe5-bdf5f9d1a184",
        "storage_key": "property/6767906449167585/019ff6cd-780a-74a0-8fe5-bdf5f9d1a184.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://totalcare.us/garland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208907124286817914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "totalcare-emergency-room",
      "poi_latitude": "32.8611741",
      "poi_longitude": "-96.6416461",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-954-9098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEYM33zOnToYRegY-tgt3T7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_8e2cbe75-3160-4e1f-aeaa-70edfe329b2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - North Garland",
      "poi_type": "Health and Wellness",
      "poi_address": "5106 N President George Bush Hwy, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-76e7-741d-ae19-23ad5b35c216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-76e7-741d-ae19-23ad5b35c216",
        "storage_key": "property/6767906449167585/019ff6cd-76e7-741d-ae19-23ad5b35c216.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.carenow.com/locations/dallas-fort-worth/garland-north?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=792629817099277073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---north-garland",
      "poi_latitude": "32.9643772",
      "poi_longitude": "-96.6380495",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-530-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f_UxBkcTIYREdOVfp78_wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c14b48b6-400e-4e81-b28b-5ac86a5a7e59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Baylor Scott & White Urgent Care - North Garland",
      "poi_type": "Health and Wellness",
      "poi_address": "7217 Telecom Pkwy Ste 100a, Garland, TX 75044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-770d-73da-b8ce-5b0cf2a58f4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-770d-73da-b8ce-5b0cf2a58f4d",
        "storage_key": "property/6767906449167585/019fc920-770d-73da-b8ce-5b0cf2a58f4d.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/clinical-group/urgent-care-north-texas/north-garland?utm_content=main-website&utm_source=pg-google&utm_medium=organic&utm_campaign=29985-9717329",
      "poi_directions_map_url": "https://maps.google.com/?cid=18036960857021072290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baylor-scott--white-urgent-care---north-garland",
      "poi_latitude": "32.9819535",
      "poi_longitude": "-96.6625591",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 469-800-2530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa06sb08dTIYRosNd5lUoUPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_0e753dac-3bf7-4a2f-b3a2-c2bb2fcf9e2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Shiloh Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2630 Arapaho Rd Ste 200, Garland, TX 75044, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-78d6-715d-8ccd-b55507a9c29b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-78d6-715d-8ccd-b55507a9c29b",
        "storage_key": "property/6767906449167585/019ff6cd-78d6-715d-8ccd-b55507a9c29b.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.shilohurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7840396160869101831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shiloh-urgent-care",
      "poi_latitude": "32.9590506",
      "poi_longitude": "-96.6670432",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 469-543-6992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_ccBOUYfTIYRB3HwosSuzmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_9a96cc10-2c21-47b7-bded-c7e4683fee22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "101 W Buckingham Rd, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-78c6-7779-aa4f-c2e2e0ac8dfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-78c6-7779-aa4f-c2e2e0ac8dfd",
        "storage_key": "property/6767906449167585/019ff6cd-78c6-7779-aa4f-c2e2e0ac8dfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/2433-garland-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8304591431550159857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "32.9320716",
      "poi_longitude": "-96.6316824",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-304-3427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-8db8-7204-8e2f-f4bdf29cbe37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6cd-8db8-7204-8e2f-f4bdf29cbe37",
        "storage_key": "property/6767906449167585/019ff6cd-8db8-7204-8e2f-f4bdf29cbe37.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3WJBrKQdTIYR8ctMSujVP3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4ccee17d-e600-42be-a4b4-e713572ab96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1902 N Jupiter Rd, Garland, TX 75042, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7be1-703c-ac41-a7de2e1f104a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7be1-703c-ac41-a7de2e1f104a",
        "storage_key": "property/6767906449167585/019ff6cd-7be1-703c-ac41-a7de2e1f104a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1902+n+jupiter+rd-garland-tx-75042/id=4267",
      "poi_directions_map_url": "https://maps.google.com/?cid=3967343920728702787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.9301786",
      "poi_longitude": "-96.6822919",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 972-487-6450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92QCDWkeTIYRQ__WqEbWDjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6e47c54d-eee9-4c8d-b364-18e3f5255a03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2380 Firewheel Pkwy, Garland, TX 75040, USA",
      "poi_short_description": "Chain gym with 24/7 access providing equipment, personal training, and group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7b21-76d8-8597-e836eabe513b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7b21-76d8-8597-e836eabe513b",
        "storage_key": "property/6767906449167585/019ff6cd-7b21-76d8-8597-e836eabe513b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/garland-texas-1193/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1193",
      "poi_directions_map_url": "https://maps.google.com/?cid=8167001674029837863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "32.9359331",
      "poi_longitude": "-96.6002172",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 972-495-6565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4jtLxYdTIYRJ66RfMAEV3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7ab4f090-c1ba-4506-bc37-f393370aaea8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 W Centerville Rd, Garland, TX 75041, USA",
      "poi_short_description": "Chain gym offering a pool, basketball court, and sauna, plus classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-6f64-74f2-a040-323b21956458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-6f64-74f2-a040-323b21956458",
        "storage_key": "property/6767906449167585/019fc920-6f64-74f2-a040-323b21956458.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=926&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6951196607411046301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.8578216",
      "poi_longitude": "-96.6478353",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 972-271-4614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdYqhiGnToYRnceiRHycd2A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_455faec6-cbb9-49e9-a23b-33965e6ff850",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Bunker Hill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4949 Bunker Hill Rd, Garland, TX 75048, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7d92-769c-9688-9c1b83e9717b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7d92-769c-9688-9c1b83e9717b",
        "storage_key": "property/6767906449167585/019ff6cd-7d92-769c-9688-9c1b83e9717b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/Bunker-Hill-Park-22",
      "poi_directions_map_url": "https://maps.google.com/?cid=12784248341404074424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bunker-hill-park",
      "poi_latitude": "32.9545988",
      "poi_longitude": "-96.5968449",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJF_-sc60dTIYRuEHE9SHGarE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b0c851c1-66e3-4737-9072-e2562d49b28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Spring Creek Forest Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1770 Holford Rd, Garland, TX 75044, USA",
      "poi_short_description": "This scenic park known for its towering trees, wildflowers & rare plants features trails & a creek.",
      "poi_long_description": "This scenic park known for its towering trees, wildflowers & rare plants features trails & a creek.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-725e-749e-9488-909960e8afb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-725e-749e-9488-909960e8afb0",
        "storage_key": "property/6767906449167585/019fc920-725e-749e-9488-909960e8afb0.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.springcreekforest.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9677198873188912901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-creek-forest-preserve",
      "poi_latitude": "32.9652529",
      "poi_longitude": "-96.6535453",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWRGRjscTIYRBU88aRpRTIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_cc0c671d-bf04-443f-8292-d0629cba18e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Rowlett Creek - Dallas County Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2525 Castle Dr, Garland, TX 75040, USA",
      "poi_short_description": "This park known for its bicycle trails also offers a pavilion, grill & picnic tables.",
      "poi_long_description": "This park known for its bicycle trails also offers a pavilion, grill & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-743e-776e-97ea-45ff726d3d7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-743e-776e-97ea-45ff726d3d7a",
        "storage_key": "property/6767906449167585/019fc920-743e-776e-97ea-45ff726d3d7a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.dallascounty.org/departments/plandev/openspaces/locations/05-rowlett-creek.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=4461175981870784767&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowlett-creek---dallas-county-nature-preserve",
      "poi_latitude": "32.9199291",
      "poi_longitude": "-96.5958299",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQcrs0AdTIYR_6DpT-tH6T0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_5c49e150-5fc3-4793-80ba-7f2a655aae1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Audubon Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "342 W Oates Rd, Garland, TX 75043, USA",
      "poi_short_description": "Gym and recreation center with a basketball court, game systems, and activities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-7c18-760c-80dd-8dfe0f74bd4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-7c18-760c-80dd-8dfe0f74bd4d",
        "storage_key": "property/6767906449167585/019fc920-7c18-760c-80dd-8dfe0f74bd4d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garlandtx.gov/facilities/facility/details/Audubon-Recreation-Center-85",
      "poi_directions_map_url": "https://maps.google.com/?cid=8619383158754370698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "audubon-recreation-center",
      "poi_latitude": "32.8478148",
      "poi_longitude": "-96.6159002",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-205-3991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0a2yJ-nToYRiuSJwFAznnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_a34cd2d5-face-420e-8e28-1565a6073590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Troth Ablon Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4498 O Banion Rd, Garland, TX 75043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-7a0f-77aa-afef-eed17d18d19d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-7a0f-77aa-afef-eed17d18d19d",
        "storage_key": "property/6767906449167585/019fc920-7a0f-77aa-afef-eed17d18d19d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandtx.gov/facilities/facility/details/trothablonpark-67",
      "poi_directions_map_url": "https://maps.google.com/?cid=14968074343302863897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "troth-ablon-park",
      "poi_latitude": "32.8635636",
      "poi_longitude": "-96.6260952",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62xRVwGnToYRGZw0nE9Iuc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_be24eec7-0e89-4739-b0fb-c7cf447626b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Gatewood Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "4917 Duck Creek Dr, Garland, TX 75043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-7fec-737c-b62f-a6a9ca574b2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-7fec-737c-b62f-a6a9ca574b2f",
        "storage_key": "property/6767906449167585/019ff6cd-7fec-737c-b62f-a6a9ca574b2f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1632257951575503648&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gatewood-pavilion",
      "poi_latitude": "32.8527416",
      "poi_longitude": "-96.6124176",
      "poi_miles_from_property": "9.7",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJdEI-9KnToYRIPN2efXxphY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_6661ca05-82e9-4baa-946c-cebe1f27a7e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Garland Parks & Recreation",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "634 Apollo Rd, Garland, TX 75040, USA",
      "poi_short_description": "Children's park offering a public restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-802d-7419-bcc4-1b5ad4f6391d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-802d-7419-bcc4-1b5ad4f6391d",
        "storage_key": "property/6767906449167585/019ff6cd-802d-7419-bcc4-1b5ad4f6391d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandtx.gov/156/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15358619051792938126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-parks--recreation",
      "poi_latitude": "32.9453995",
      "poi_longitude": "-96.6383533",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA_7AjLQdTIYRjjSqdqfGJNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_01e8ef0f-44ff-4a9e-886a-4ba5fd07918a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Embree Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1515 Dairy Rd, Garland, TX 75040, USA",
      "poi_short_description": "Green space offering picnic tables, a playground, a basketball court, a walking trail, and a splash pad.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-7e91-766a-b9a2-bf4a65cb74a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-7e91-766a-b9a2-bf4a65cb74a3",
        "storage_key": "property/6767906449167585/019fc920-7e91-766a-b9a2-bf4a65cb74a3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://garlandtx.gov/Facilities/Facility/Details/Embree-Park-34",
      "poi_directions_map_url": "https://maps.google.com/?cid=3340823490795808429&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "embree-park",
      "poi_latitude": "32.8980909",
      "poi_longitude": "-96.6233005",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 972-205-2750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4qBLH-nToYRrSYqskP9XC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f94fc0be-ce67-4d43-b036-5ead054fec5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Springfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Antioch Dr, Rowlett, TX 75089, USA",
      "poi_short_description": "Lakeside park on 117 acres with football fields, disc golf & a playground, plus an R/C airfield.",
      "poi_long_description": "Lakeside park on 117 acres with football fields, disc golf & a playground, plus an R/C airfield.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-81ba-759f-a4b3-7e4fc8e22d81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-81ba-759f-a4b3-7e4fc8e22d81",
        "storage_key": "property/6767906449167585/019ff6cd-81ba-759f-a4b3-7e4fc8e22d81.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rowlett.com/facilities.aspx?search=1&CID=1&RID=14&Page=detail",
      "poi_directions_map_url": "https://maps.google.com/?cid=6764212631777039439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springfield-park",
      "poi_latitude": "32.910095",
      "poi_longitude": "-96.590034",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 972-412-6170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-872cb4f37a8f",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-872cb4f37a8f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYl4kVodTIYRT9RH3oxP310",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3c5d9a83-7ce5-4156-9d3f-4415802407e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Lake Ray Hubbard Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "6151 Duck Creek Dr, Garland, TX 75043, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-8234-723c-b8fb-bd2d7503502b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-8234-723c-b8fb-bd2d7503502b",
        "storage_key": "property/6767906449167585/019ff6cd-8234-723c-b8fb-bd2d7503502b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/lakerayhubbardtransitcenter.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=12088869112523893110&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-ray-hubbard-transit-center",
      "poi_latitude": "32.8430801",
      "poi_longitude": "-96.6016047",
      "poi_miles_from_property": "10.6",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c08c-7789-bd3c-00f963d097ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c08c-7789-bd3c-00f963d097ae",
        "storage_key": "property/6767906449167585/019fc920-c08c-7789-bd3c-00f963d097ae.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ95_TDUemToYRdqkthGhKxKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_37f48290-ba91-409d-a4ce-4bf80ba2f9cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "South Garland Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4051 Leon Rd, Garland, TX 75041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-8205-70ef-8edb-907bed016dae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-8205-70ef-8edb-907bed016dae",
        "storage_key": "property/6767906449167585/019fc920-8205-70ef-8edb-907bed016dae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/southgarlandtransitcenter.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=14878736467210160186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-garland-transit-center",
      "poi_latitude": "32.868086",
      "poi_longitude": "-96.6631265",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c08c-7789-bd3c-00f963d097ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c08c-7789-bd3c-00f963d097ae",
        "storage_key": "property/6767906449167585/019fc920-c08c-7789-bd3c-00f963d097ae.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyQQpjKnToYROki2avzje84",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_4ea4f92e-177a-4a0a-81bf-cfc56ea67019",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Downtown Garland Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "430 W Walnut St, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-805c-74d6-b37c-0dd7fc02dd4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-805c-74d6-b37c-0dd7fc02dd4b",
        "storage_key": "property/6767906449167585/019fc920-805c-74d6-b37c-0dd7fc02dd4b.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4772984402673695142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-garland-station",
      "poi_latitude": "32.9174029",
      "poi_longitude": "-96.6357499",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c07b-70b9-b527-c89a5e5bd003.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c07b-70b9-b527-c89a5e5bd003",
        "storage_key": "property/6767906449167585/019fc920-c07b-70b9-b527-c89a5e5bd003.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeDPD5EdTIYRpnnYnwYMPUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_d2a917b7-1732-49d5-8359-b44ffd8658fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Forest / Jupiter",
      "poi_type": "Transportation & Transit",
      "poi_address": "3232 Forest Ln, Garland, TX 75042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-6028-731e-a0e6-4284c65df503.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-6028-731e-a0e6-4284c65df503",
        "storage_key": "property/6767906449167585/019fc91c-6028-731e-a0e6-4284c65df503.webp",
        "width": 852,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/forestjupiterstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=18241006461951380148&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest--jupiter",
      "poi_latitude": "32.9081082",
      "poi_longitude": "-96.6793834",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-85c3-75eb-b403-3e1efaea4080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-85c3-75eb-b403-3e1efaea4080",
        "storage_key": "property/6767906449167585/019fc91c-85c3-75eb-b403-3e1efaea4080.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJoXHJ2hseTIYRtIo3brsSJf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_4d321f2c-27ac-41df-a8da-cf58061bfb60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Downtown Rowlett",
      "poi_type": "Transportation & Transit",
      "poi_address": "5000 Martin Dr, Rowlett, TX 75088, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-6011-77fb-8c10-b4477de46306.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-6011-77fb-8c10-b4477de46306",
        "storage_key": "property/6767906449167585/019fc91c-6011-77fb-8c10-b4477de46306.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.dart.org/riding/stations/downtownrowlettstation.asp?zeon=blue",
      "poi_directions_map_url": "https://maps.google.com/?cid=11066164895002160789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-rowlett",
      "poi_latitude": "32.9041373",
      "poi_longitude": "-96.5634519",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-979-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-85c3-75eb-b403-3e1efaea4080.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-85c3-75eb-b403-3e1efaea4080",
        "storage_key": "property/6767906449167585/019fc91c-85c3-75eb-b403-3e1efaea4080.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJaak9tR2oToYRlW6ASFfqkpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_5cc95b32-551a-47fe-80a8-6eb574b7d111",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Dallas Fort Worth International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2400 Aviation Dr, DFW Airport, TX 75261, USA",
      "poi_short_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_long_description": "Sprawling complex (17,000+ sq. acres) serving North Texas, with direct rail service to Dallas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-8304-758a-83aa-582e5a4031e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-8304-758a-83aa-582e5a4031e1",
        "storage_key": "property/6767906449167585/019fc920-8304-758a-83aa-582e5a4031e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dfwairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8300766736265584668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dallas-fort-worth-international-airport",
      "poi_latitude": "32.8921983",
      "poi_longitude": "-97.0391232",
      "poi_miles_from_property": "31.5",
      "poi_walking_minutes": "11 hours 44 mins",
      "poi_biking_minutes": "3 hours 20 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 972-973-3112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c0d0-7374-9749-16dfff7efc78.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c0d0-7374-9749-16dfff7efc78",
        "storage_key": "property/6767906449167585/019fc920-c0d0-7374-9749-16dfff7efc78.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJpyoiDWYqTIYRHCB9Bl4_MnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_4979e350-2f46-45ef-9003-c30a0b5f8ea2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Raytheon City line",
      "poi_type": "Transportation & Transit",
      "poi_address": "1717 E CityLine Dr, Richardson, TX 75082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-85b7-7789-ab70-4d59bc66e23b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-85b7-7789-ab70-4d59bc66e23b",
        "storage_key": "property/6767906449167585/019ff6cd-85b7-7789-ab70-4d59bc66e23b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12500849932832838390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raytheon-city-line",
      "poi_latitude": "32.9999753",
      "poi_longitude": "-96.690021",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-301-0564",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzmvqTAZTIYR9pL3FMjwe60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_c368c19c-f96c-40ea-b13c-33e0d01f0bda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Garland VA Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Marie Curie Blvd, Garland, TX 75042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-57fa-7629-90c1-ba1f45bebe99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc91c-57fa-7629-90c1-ba1f45bebe99",
        "storage_key": "property/6767906449167585/019fc91c-57fa-7629-90c1-ba1f45bebe99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.northtexas.va.gov/locations/Garland_VAMC.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=4557347573635622006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-va-medical-center",
      "poi_latitude": "32.9193128",
      "poi_longitude": "-96.6626672",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 469-797-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8209-731f-adf6-8f089666f136.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8209-731f-adf6-8f089666f136",
        "storage_key": "property/6767906449167585/019fc91c-8209-731f-adf6-8f089666f136.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4-cOPIdTIYRdiSK7HjzPj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_05921214-7b27-40f9-b16a-ee23a1d77ae9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Amazon Flex Delivery Fullfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3900 Distribution Dr, Garland, TX 75041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-9244-7059-9da8-64991a6f0984.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-9244-7059-9da8-64991a6f0984",
        "storage_key": "property/6767906449167585/019fc920-9244-7059-9da8-64991a6f0984.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7573994606176102518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-flex-delivery-fullfillment-center",
      "poi_latitude": "32.8930671",
      "poi_longitude": "-96.6871478",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 214-742-0662",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Y4zJJmgToYRdujZL_c7HGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_16a1b52d-1de2-4e35-8db3-283208845a53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Garland Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "501 S Jupiter Rd, Garland, TX 75042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-8da8-73a3-9f49-5452f70033fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-8da8-73a3-9f49-5452f70033fd",
        "storage_key": "property/6767906449167585/019fc920-8da8-73a3-9f49-5452f70033fd.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://www.garlandisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=557013818549010741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-independent-school-district",
      "poi_latitude": "32.9086679",
      "poi_longitude": "-96.6835931",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 972-494-8201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7W6qUpunToYRNQGZ5R3pugc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_401368bb-914a-4e5f-92b9-ad6b20b98e87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Garland City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 N 5th St, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-8d46-7439-ad43-e4ca3088b18e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-8d46-7439-ad43-e4ca3088b18e",
        "storage_key": "property/6767906449167585/019fc920-8d46-7439-ad43-e4ca3088b18e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.garlandtx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16316639176539699962&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garland-city-hall",
      "poi_latitude": "32.9136369",
      "poi_longitude": "-96.6362934",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 972-205-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-c0d3-741d-bd79-34f29a898acc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc920-c0d3-741d-bd79-34f29a898acc",
        "storage_key": "property/6767906449167585/019fc920-c0d3-741d-bd79-34f29a898acc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-cZG44dTIYR-vreveFYcOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_f2677e52-27ea-4914-bef6-c17ca3519d35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Epiroc Drilling Solutions LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 N First St, Garland, TX 75040, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-8628-763c-a54c-f0babb269e63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-8628-763c-a54c-f0babb269e63",
        "storage_key": "property/6767906449167585/019ff6cd-8628-763c-a54c-f0babb269e63.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.epiroc.com/en-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12870629157960226173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epiroc-drilling-solutions-llc",
      "poi_latitude": "32.9334861",
      "poi_longitude": "-96.62768400000002",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 972-496-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMSZsOKQdTIYRfRUBFAepnbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_78c56696-b790-4b8f-869d-c4c3b42af550",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "The University of Texas at Dallas",
      "poi_type": "Education",
      "poi_address": "800 W Campbell Rd, Richardson, TX 75080, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc920-9056-74df-8f90-337d2b21b117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc920-9056-74df-8f90-337d2b21b117",
        "storage_key": "property/6767906449167585/019fc920-9056-74df-8f90-337d2b21b117.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.utdallas.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15639184231805621041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-dallas",
      "poi_latitude": "32.9859295",
      "poi_longitude": "-96.7503304",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 972-883-2111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-8208-75fa-8efe-6d69794e0dbb",
        "storage_key": "property/6767906449167585/019fc91c-8208-75fa-8efe-6d69794e0dbb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpUpeif8hTIYRMROq6TKLCdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_87941326-2b47-44f6-9d4d-aca5aef1e906",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Cisco Building 6",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2300 E President George Bush Hwy, Richardson, TX 75082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-8871-776a-af46-3c706b30658f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-8871-776a-af46-3c706b30658f",
        "storage_key": "property/6767906449167585/019ff6cd-8871-776a-af46-3c706b30658f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cisco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9528907413609613270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cisco-building-6",
      "poi_latitude": "32.9998923",
      "poi_longitude": "-96.6788863",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 469-255-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvaeZ0aoeTIYR1ofJbc56PYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_34a8e9f3-94ce-401a-8099-fa706fc0dbfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "poi_name": "Toyota Motor North America, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6565 Headquarters Dr, Plano, TX 75024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019ff6cd-86ec-77b5-8137-88eb290d1164.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6cd-86ec-77b5-8137-88eb290d1164",
        "storage_key": "property/6767906449167585/019ff6cd-86ec-77b5-8137-88eb290d1164.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.toyota.com/usa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16701516526272220353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-north-america-inc",
      "poi_latitude": "33.0811809",
      "poi_longitude": "-96.841015",
      "poi_miles_from_property": "19.1",
      "poi_walking_minutes": "7 hours 7 mins",
      "poi_biking_minutes": "1 hour 50 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 469-292-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc91c-828b-736c-8ffc-80f04e473334",
        "storage_key": "property/6767906449167585/019fc91c-828b-736c-8ffc-80f04e473334.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJedgAaVc7TIYRwYzFzsq0x-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f1f0c0984319f66ad7f4ad53",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0fc6eecb8dd6021a5e73e43f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c1b40263c97f78be042f6e3e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d7894289e7037bed585734a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7aa1af0b0c65180f339523fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dac71e90fda6d23ddc1a332f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_63202c2476099cac0b123985",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "rating": "5",
      "name": "Tiffany Mitchell",
      "text": "Update ***\nI have lived here for 3 months now and it has been such a lovely experience. I am blown away by the hard working maintenance team and by both of the managers. Meagan was originally my leasing agent but has since been promoted to Assistant Manager and she still continues to be a reliable and dependable point of contact for the Leasing Office. In fact, she is the only person who responds to my emails when I do reach out. She is amazing 🥰. Dana (the Property Manager) does a fantastic job of communicating with the residents via mass emails and keeping everyone updated and informed. There are tons of residents events monthly. I’ve never been to one, it’s not my thing- but for those that love this, they really do a great job of community engagement + activities!!\n\nThe maintenance team (Dakota, Walter and Zach) is extremely dedicated and I’m super impressed. I have a unit where the attic door to the roof is right in front of my hallway door and they have been diligently working on one of my neighbor’s AC unit all-day today and yesterday. They have stayed well past their normal work hours to make sure they resolved the issue. They even cleaned up the hallway in front of my unit. All three guys deserve recognition (I don’t know their names… Just know hard work doesn’t go unnoticed!!!) It’s truly because of them that I wanted to update my review and shout them out.\n\nI LOVE my view and my home is so peaceful. I had an issue with an inconsiderate neighbor during ‘quiet hours’, but once addressed by Meagan it has since been resolved. Highly recommend that if you’re looking for a home and a pond-view unit is available you better snag it real quick like- you won’t regret it!!\n\nAlso, for those that read reviews and may not be familiar- I do think it’s important to note that some reviewers are placing blame unjustifiably and it’s not a lack of professionalism on the office’ part when it comes to move outs, community policies, etc. Not to diminish anyone’s move-out experience but if you receive specials and break your lease it is STANDARD to pay back your concessions AND have an early termination fee. That’s normal and ALL management companies enforce this. 🤦🏻‍♀️ it is always so interesting to see those types of reviews when your lease agreement states this… 👀\n\nInitial Review: I had such a lovely experience with Meagan today! She showed me around the community and a couple of floor plans to help me dial down the perfect home for me. I also want to give the Manager (Dana) a shoutout as she was my first point of contact and helped me over the phone with all my questions and got me scheduled for my tour. I am so excited for what the future will look like for me at Rye!",
      "date": "2026-04-01",
      "title": "false"
    },
    {
      "id": "ec_44fc444349c4d299a5e1292d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "rating": "5",
      "name": "Lily Olguin",
      "text": "I had a wonderful experience working with Catherine Soler in the leasing office. Throughout our entire application and approval process she was very helpful and polite. She made things very easy and simple to understand regarding all of the necessary steps we needed to take to get our dream apartment. Overall, my experience with the Rye Bunker Hill Leasing Team has been very pleasant and my first impressions of the apartments would have to be a 10/10. The property is well maintained and very beautiful!",
      "date": "2026-06-02",
      "title": "false"
    },
    {
      "id": "ec_bfb6c4b05c844b38ec934237",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "rating": "5",
      "name": "Emeline Garcia",
      "text": "I LOVE EVERYTHING ABOUT THE COMPLEX. From the moment I toured to the day I moved in, the entire experience has been amazing. The move-in process was quick and easy, and the application process was simple and stress-free.\n\nThe maintenance team is AWESOME — huge shoutout to Dakota and Walter for addressing my issues so quickly and professionally. Catherine was incredibly helpful throughout the entire process, and I truly appreciate all of her support.\n\nThe community is beautiful and well-kept, even the trash compactor area was super clean. My neighbors are also so sweet and welcoming. The amenities 10000/10. Overall, I’m beyond happy with my experience here and truly love living here! 😁❤️🎉🎉",
      "date": "2026-05-26",
      "title": "false"
    },
    {
      "id": "ec_22ddbab1750d51cf0139ceae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "rating": "5",
      "name": "Kylee Taylor",
      "text": "Dakota is awesome! He’s very personable with the residents that live here. We’ve had an issue with moisture building up underneath one of our windows. He came up and fixed it quickly and has a plan for if/when it happens again in the future. I’ve had my fair share of experiences with maintenance staff from various complexes, and he is the best by far!",
      "date": "2026-06-16",
      "title": "false"
    },
    {
      "id": "ec_a64883d1508a60f107d35e1d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "rating": "5",
      "name": "Salvador Torres",
      "text": "I just moved into the Rye Bunker Hill Apartments and so far I am really enjoying my experience. The leasing office was very helpful in helping me submit my application and getting approved quickly. Kristyn Van Hooser was also wonderful to work with and very kind. The apartment complex is very clean and well maintained. I haven't had any bad experiences regarding the parking or apartment entry. So far I would definitely recommend moving here!",
      "date": "2026-06-02",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a01039-f506-7348-85e0-1239252a2fbb",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Rye Bunker Hill Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585"
    },
    {
      "lead_collector_id": "01a01039-f59f-725e-8ab8-dfc91c02e734",
      "lead_source": "LANDING_PAGE",
      "name": "Rye Bunker Hill Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "luxury-apartments-dog-park-near-dallas-county",
      "search_query": "luxury apartments with dog park near dallas county",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dog Park Near Dallas",
      "h2_subtitle": "Find luxury apartments near Dallas County. Enjoy the convenience of a private dog park and premium amenities today.",
      "page_copy": "Discover the ideal blend of luxury and pet-friendly living at Rye Bunker Hill, offering exquisite apartments near Dallas County complete with a dedicated dog park. Our one, two, and three-bedroom apartments are designed with modern elegance and feature premium finishes that define stylish living.\n\nBeyond our beautifully crafted interiors, our community amenities, such as a clubhouse and a lakeside cabana, ensure a resort-style experience. Located conveniently in Garland, TX, near Dallas County, Rye Bunker Hill is the ideal home for you and your furry friends. Visit us today and step into a lifestyle where luxury meets comfort and pet-friendly convenience!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dog Park Near Dallas",
      "seo_description": "Explore luxury apartments with a dog park at Rye Bunker Hill near Dallas County. Modern living with pet-friendly amenities awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-spa-garland",
      "search_query": "pet friendly apartments with spa in garland",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Spa in Garland",
      "h2_subtitle": "Looking for pet-friendly apartments in Garland with a spa? Discover luxurious living spaces at Rye Bunker Hill.",
      "page_copy": "Welcome to Rye Bunker Hill, where pet-friendly living meets luxury in our apartments featuring exclusive access to a spa in Garland. Our one, two, and three-bedroom apartments are designed with both comfort and style in mind, making them perfect for you and your furry companions.\n\nResidents enjoy a range of amenities, including a resort-style spa, fully equipped kitchens, and inviting cabanas. Located conveniently in Garland, Rye Bunker Hill is the ultimate pet-friendly community, offering not just a home, but a lifestyle filled with relaxation and luxury. Connect with us today and schedule a tour of your future sanctuary!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Spa in Garland",
      "seo_description": "Explore pet-friendly apartments with a spa at Rye Bunker Hill in Garland. Experience luxury living with your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-garland-tx",
      "search_query": "one bedroom apartments garland tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Garland, TX",
      "h2_subtitle": "Explore spacious one bedroom apartments in Garland, TX at Rye Bunker Hill. Perfect for your modern lifestyle.",
      "page_copy": "Discover the charm of our one bedroom apartments in Garland, TX at Rye Bunker Hill. These thoughtfully designed spaces offer modern finishes and ample room, ideal for comfortable living. With polished interiors, our one-bedroom units provide a perfect retreat in the bustling city.\n\nLocated in the heart of Garland, Rye Bunker Hill offers an array of community amenities, including a cabana, clubhouse, and beautiful lake access. Conveniently situated near the elevator, these apartments make everyday living effortless. Experience a vibrant lifestyle—schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Garland, TX",
      "seo_description": "Explore sophisticated one bedroom apartments in Garland, TX at Rye Bunker Hill. Enjoy modern features and prime amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-dallas-county",
      "search_query": "two bedroom apartments near dallas county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Dallas County",
      "h2_subtitle": "Discover spacious two bedroom apartments near Dallas County at Rye Bunker Hill. Perfectly situated for convenience and comfort.",
      "page_copy": "Experience comfortable urban living in our two bedroom apartments near Dallas County. At Rye Bunker Hill, we offer stylish living spaces designed to suit modern lifestyles. Each apartment features polished finishes and open layouts, providing a relaxing and inviting ambiance.\n\nLocated just a short drive from Dallas County, Rye Bunker Hill is positioned in a prime location in Garland. Residents enjoy a range of premium amenities, such as a clubhouse and lake access, ensuring an enhanced living experience. Tour our two-bedroom units today and discover your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near Dallas County",
      "seo_description": "Find two bedroom apartments near Dallas County at Rye Bunker Hill. Enjoy top amenities and a prime location in Garland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-75048",
      "search_query": "three bedroom apartments 75048",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in 75048",
      "h2_subtitle": "Explore spacious three bedroom apartments in the 75048 area at Rye Bunker Hill. Ideal for families and roommates alike.",
      "page_copy": "Nestled in the heart of the 75048 area, Rye Bunker Hill offers stunning three bedroom apartments tailored for those seeking ample space and modern living. Each unit boasts a contemporary design with polished finishes that enhance the spacious interiors, providing room for everyone.\n\nLiving at Rye Bunker Hill means enjoying unparalleled amenities, such as direct lake access, a charming cabana, and convenient proximity to elevators. Whether you're a growing family or looking for a home with extra room, our three-bedroom apartments are the perfect choice. Schedule a tour today and step into comfort and style.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in 75048",
      "seo_description": "Explore Rye Bunker Hill's spacious three bedroom apartments in the 75048 zip code. Perfect for modern living, complete with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-near-robert-sewell-elementary-garland",
      "search_query": "apartments near Robert B. Sewell Elementary School Garland",
      "category": "School",
      "h1_title": "Apartments Near Robert B. Sewell Elementary",
      "h2_subtitle": "Discover convenient apartments near Robert B. Sewell Elementary School in Garland. Ideal for those seeking proximity to education.",
      "page_copy": "Rye Bunker Hill offers an ideal living solution for those seeking apartments near Robert B. Sewell Elementary School in Garland. Our community provides a range of one-, two-, and three-bedroom homes equipped with modern amenities and high-quality finishes, perfect for convenient living.\n\nSituated in a prime location in Garland, Rye Bunker Hill residents enjoy quick access to Robert B. Sewell Elementary and other local conveniences. With community features like a welcoming clubhouse and lake access, our apartments offer both comfort and practicality. Come tour our property today and discover your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Robert B. Sewell Elementary Garland",
      "seo_description": "Find ideal apartments near Robert B. Sewell Elementary School at Rye Bunker Hill in Garland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-close-john-armstrong-elementary-tx",
      "search_query": "apartments close to John W. Armstrong Elementary School TX",
      "category": "School",
      "h1_title": "Apartments Close to John W. Armstrong Elementary",
      "h2_subtitle": "Explore apartments close to John W. Armstrong Elementary School in TX. Rye Bunker Hill is just around the corner.",
      "page_copy": "For those looking for apartments close to John W. Armstrong Elementary School, Rye Bunker Hill offers the perfect blend of proximity and style. Located just a short distance away in Garland, TX, our modern apartments are ideal for those prioritizing education and convenience.\n\nResidents of Rye Bunker Hill benefit from a host of amenities including a clubhouse and accessible lake views, all while enjoying the ease of quickly reaching John W. Armstrong Elementary. Our spacious one-, two-, and three-bedroom units are designed with you in mind, making them a great choice for your new home. Book a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to John W. Armstrong Elementary",
      "seo_description": "Discover Rye Bunker Hill, offering apartments close to John W. Armstrong Elementary in TX, perfect for those seeking proximity and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "residences-near-bg-hudson-middle-school-dallas-county",
      "search_query": "residences near B. G. Hudson Middle School Dallas County",
      "category": "School",
      "h1_title": "Residences Near B. G. Hudson Middle School",
      "h2_subtitle": "Find charming residences near B. G. Hudson Middle School in Dallas County, offering convenience and upscale living.",
      "page_copy": "Located in the vibrant community of Garland, TX, Rye Bunker Hill provides stylish residences near B. G. Hudson Middle School, making it a prime choice for those in Dallas County. Our contemporary one-, two-, and three-bedroom apartments are thoughtfully designed with high-quality finishes and ample space.\n\nRye Bunker Hill boasts an array of community amenities, including a serene lake access, a modern clubhouse, and a nearby cabana, ensuring a comfortable lifestyle. You will appreciate the close proximity to B. G. Hudson Middle School, allowing easy commutes and more quality time at home. Experience the best of residential living by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near B. G. Hudson Middle School",
      "seo_description": "Discover modern residences near B. G. Hudson Middle School at Rye Bunker Hill, offering top amenities in Dallas County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "flats-near-sellers-middle-school-garland",
      "search_query": "flats near Sellers Middle School Garland",
      "category": "School",
      "h1_title": "Flats Near Sellers Middle School Garland",
      "h2_subtitle": "Discover flats near Sellers Middle School in Garland, offering a blend of modern living and educational convenience.",
      "page_copy": "Located in the heart of Garland, Rye Bunker Hill presents a selection of stylish flats near Sellers Middle School, ideal for those seeking convenience and quality. Our one-, two-, and three-bedroom apartments feature contemporary finishes and spacious layouts tailored to suit today's modern lifestyle.\n\nWith easy access to Sellers Middle School, these flats ensure a seamless daily routine for you. Rye Bunker Hill also boasts desirable amenities, including a welcoming clubhouse and convenient lake access. Experience the perfect living environment by scheduling a visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flats Near Sellers Middle School Garland",
      "seo_description": "Explore modern flats near Sellers Middle School in Garland at Rye Bunker Hill, offering easy access and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-near-sachse-high-school-75048",
      "search_query": "apartments near Sachse High School 75048",
      "category": "School",
      "h1_title": "Apartments Near Sachse High School 75048",
      "h2_subtitle": "Explore apartments near Sachse High School in the 75048 area. Discover top living at Rye Bunker Hill.",
      "page_copy": "Rye Bunker Hill offers elegantly designed apartments near Sachse High School, providing those in the 75048 area with the perfect combination of comfort and convenience. Our one-, two-, and three-bedroom units feature modern finishes and spacious interiors, ideal for accommodating your needs.\n\nSituated in Garland, TX, this community boasts proximity to Sachse High School, ensuring effortless commutes for students. Residents here can enjoy extensive amenities like a modern clubhouse and scenic lake access, enhancing the everyday living experience. Schedule a tour today to discover how Rye Bunker Hill can perfectly complement your lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sachse High School 75048",
      "seo_description": "Find spacious apartments near Sachse High School in the 75048 zip code at Rye Bunker Hill, featuring modern amenities just steps away.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "rentals-near-firewheel-christian-academy-garland",
      "search_query": "rentals near Firewheel Christian Academy Garland",
      "category": "School",
      "h1_title": "Rentals Near Firewheel Christian Academy",
      "h2_subtitle": "Discover premium rentals near Firewheel Christian Academy in Garland. Experience comfortable living today.",
      "page_copy": "Nestled in the vibrant community of Garland, Rye Bunker Hill provides exceptional rentals near Firewheel Christian Academy, perfect for those seeking convenience and top-quality education. Our thoughtfully crafted one-, two-, and three-bedroom apartments offer stylish finishes and modern comforts.\n\nPositioned just minutes from Firewheel Christian Academy, these rentals make commutes simple and stress-free. Enjoy premium community features like a spacious clubhouse, lake access for outdoor relaxation, and proximity near local amenities. Schedule a tour today to find out why Rye Bunker Hill is the ideal choice for living in Garland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Firewheel Christian Academy Garland",
      "seo_description": "Explore modern rentals near Firewheel Christian Academy in Garland at Rye Bunker Hill, offering top amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-close-to-collin-college-spring-creek-campus-tx",
      "search_query": "apartments close to Collin College - Spring Creek Campus TX",
      "category": "School",
      "h1_title": "Apartments Near Collin College - Spring Creek",
      "h2_subtitle": "Explore living in apartments close to Collin College - Spring Creek Campus, TX. Embrace convenience and style at Rye Bunker Hill.",
      "page_copy": "Rye Bunker Hill offers stylish apartments close to Collin College - Spring Creek Campus, TX, making it an ideal spot for students and professionals seeking accessibility and modern living. Choose from our impeccably designed one-, two-, and three-bedroom units, all featuring high-quality finishes.\n\nEasily commute to the Spring Creek Campus while enjoying a rich array of amenities, including resort-style cabanas and clubhouse facilities. Our Garland location ensures both an engaging social life and peaceful rest, striking the perfect balance you need. Come take a tour and see why Rye Bunker Hill is a smart choice for collegiate living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Collin College - Spring Creek",
      "seo_description": "Find modern apartments close to Collin College’s Spring Creek Campus, TX. Rye Bunker Hill provides comfort and convenience in prime Garland location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "housing-near-university-of-texas-at-dallas",
      "search_query": "housing near University of Texas at Dallas",
      "category": "School",
      "h1_title": "Housing Near University of Texas at Dallas",
      "h2_subtitle": "Locate premium housing near the University of Texas at Dallas. Experience modern comfort at Rye Bunker Hill in Garland.",
      "page_copy": "Rye Bunker Hill provides excellent housing options near the University of Texas at Dallas, blending convenience and contemporary design for students and professionals. Our selection of one-, two-, and three-bedroom apartments offers refined living with polished interiors.\n\nLocated in Garland, this community simplifies access to UTD while offering a serene residential environment. Features such as a welcoming clubhouse, luxurious cabanas, and scenic lake access enhance day-to-day life. Schedule a visit today to experience why Rye Bunker Hill is perfect for those seeking high-quality housing near the University of Texas at Dallas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near University of Texas at Dallas",
      "seo_description": "Discover modern housing near the University of Texas at Dallas at Rye Bunker Hill, offering refined living in Garland with convenient access to UTD.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-near-garland-va-medical-center",
      "search_query": "apartments near Garland VA Medical Center",
      "category": "Hospital",
      "h1_title": "Apartments Near Garland VA Medical Center",
      "h2_subtitle": "Find comfortable apartments near Garland VA Medical Center. Enjoy contemporary living at Rye Bunker Hill.",
      "page_copy": "Experience the convenience of living in apartments near Garland VA Medical Center at Rye Bunker Hill. Our community offers easy access to the medical center, perfect for healthcare professionals and patients seeking nearby accommodations. Enjoy modern one-, two-, and three-bedroom units with polished finishes tailored for comfort.\n\nLocated in the heart of Garland, these apartments boast a variety of amenities such as a relaxing cabana area and a welcoming clubhouse, making it easy to unwind after a busy day. With quick connections to the Garland VA Medical Center, Rye Bunker Hill perfectly balances convenience and sophistication. Visit us for a tour and discover a stress-free lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Garland VA Medical Center",
      "seo_description": "Explore modern apartments near Garland VA Medical Center at Rye Bunker Hill, providing comfort and easy access in a prime Garland location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-near-bunker-hill-park-garland",
      "search_query": "apartments near Bunker Hill Park Garland",
      "category": "Park",
      "h1_title": "Apartments Near Bunker Hill Park, Garland",
      "h2_subtitle": "Discover contemporary living in apartments near Bunker Hill Park in Garland. Enjoy the community lifestyle at Rye Bunker Hill.",
      "page_copy": "Situated near the scenic Bunker Hill Park, Rye Bunker Hill offers elegant living in the heart of Garland. Our selection of spacious one-, two-, and three-bedroom apartments provides residents with stylish interiors and modern amenities, ideal for those seeking proximity to the park's natural beauty.\n\nRye Bunker Hill's location ensures easy access to outdoor activities while offering premium facilities like a luxurious clubhouse and a serene cabana area for relaxation. Embrace the perfect blend of nature and luxury living by visiting us today. Discover how Rye Bunker Hill fits into your active lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bunker Hill Park, Garland",
      "seo_description": "Find luxurious apartments near Bunker Hill Park in Garland. Rye Bunker Hill combines park proximity with modern amenities for a lifestyle you'll love.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "garland-apartments-near-garland-parks-recreation",
      "search_query": "Garland apartments close to Garland Parks & Recreation",
      "category": "Park",
      "h1_title": "Garland Apartments Close to Parks & Recreation",
      "h2_subtitle": "Discover Rye Bunker Hill, offering Garland apartments close to Garland Parks & Recreation. Enjoy vibrant community living.",
      "page_copy": "Rye Bunker Hill offers exceptional living in Garland, with our apartments conveniently close to Garland Parks & Recreation facilities. Perfect for active individuals and families, our community provides modern one-, two-, and three-bedroom apartments complemented by polished finishes and thoughtful design.\n\nExperience the blend of outdoor and luxury living with direct access to Garland's rich recreational offerings, including scenic parks and a robust program of activities. Residents enjoy our exclusive amenities, such as a chic clubhouse and relaxing cabana, enhancing your lifestyle every day. Visit Rye Bunker Hill and see why our location is ideal for both recreation and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garland Apartments Close to Parks & Recreation",
      "seo_description": "Explore Rye Bunker Hill's modern apartments in Garland, perfectly situated near Garland Parks & Recreation for active living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "live-close-springfield-park-dallas-county",
      "search_query": "live close to Springfield Park Dallas County",
      "category": "Park",
      "h1_title": "Live Close to Springfield Park in Dallas County",
      "h2_subtitle": "Enjoy living close to Springfield Park in Dallas County at Rye Bunker Hill. Experience a unique blend of modern living and leisure.",
      "page_copy": "Rye Bunker Hill is your gateway to vibrant living in Dallas County, with close proximity to Springfield Park. Our community offers a selection of one-, two-, and three-bedroom apartments that combine polished modern interiors with the tranquility of nature right at your doorstep.\n\nSet within easy reach of Springfield Park, residents can enjoy a range of outdoor activities while benefiting from our on-site amenities like a stylish clubhouse and peaceful cabana. Rye Bunker Hill is not just a place to live; it's a lifestyle that embraces both urban convenience and natural beauty. Visit us and discover your perfect home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Live Close to Springfield Park in Dallas County",
      "seo_description": "Rye Bunker Hill offers modern apartments near Springfield Park in Dallas County. Enjoy the perfect mix of nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "apartments-near-forest-jupiter-garland",
      "search_query": "apartments near Forest / Jupiter Garland",
      "category": "Transit",
      "h1_title": "Apartments Near Forest/Jupiter Garland",
      "h2_subtitle": "Explore Rye Bunker Hill, located near Forest/Jupiter Garland. Experience convenient living with modern amenities and community access.",
      "page_copy": "Discover sophisticated living at Rye Bunker Hill, where our apartments are strategically located near the bustling Forest and Jupiter intersection in Garland. Offering one-, two-, and three-bedroom layouts, each apartment showcases polished finishes and practical design, perfect for contemporary living.\n\nOur residents benefit from a variety of amenities, including a vibrant clubhouse and a relaxing cabana, all within easy reach of Garland's key spots. Proximity to Forest/Jupiter means effortless access to shopping, dining, and entertainment, making Rye Bunker Hill the ideal choice for those seeking a blend of comfort and convenience in Garland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Forest/Jupiter Garland",
      "seo_description": "Find modern apartments at Rye Bunker Hill near Forest/Jupiter in Garland. Enjoy upscale living with quick access to local amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "garland-tx-apartments-near-downtown-rowlett",
      "search_query": "Garland TX apartments near Downtown Rowlett",
      "category": "Transit",
      "h1_title": "Garland TX Apartments Near Downtown Rowlett",
      "h2_subtitle": "Discover stylish Garland TX apartments at Rye Bunker Hill, located conveniently near Downtown Rowlett. Enjoy modern living and local amenities.",
      "page_copy": "Experience the best of both worlds at Rye Bunker Hill, where our Garland, TX apartments offer seamless access to Downtown Rowlett. Choose from our curated selection of one-, two-, and three-bedroom units, designed with comfort and modern style in mind for those who desire a contemporary home environment.\n\nNestled in a vibrant community, residents enjoy resort-style amenities and the convenience of being just minutes away from the charm and excitement of Downtown Rowlett. Whether it's exploring local shops or relaxing by our cabana, Rye Bunker Hill provides a perfect balance of lifestyle and location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Garland TX Apartments Near Downtown Rowlett",
      "seo_description": "Rye Bunker Hill offers modern Garland TX apartments near Downtown Rowlett, combining convenience and style in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167585",
      "source": "custom",
      "page_item_url": "dallas-county-apartments-near-dfw-airport",
      "search_query": "Dallas County apartments close to Dallas Fort Worth International Airport",
      "category": "Transit",
      "h1_title": "Dallas County Apartments Near DFW Airport",
      "h2_subtitle": "Explore Rye Bunker Hill's prime location in Dallas County. Live close to Dallas Fort Worth International Airport and enjoy seamless connectivity.",
      "page_copy": "Welcome to Rye Bunker Hill, where our apartments in Dallas County boast a strategic location close to Dallas Fort Worth International Airport. Perfect for frequent flyers and travel enthusiasts, our one-, two-, and three-bedroom apartments offer modern design and enhanced comfort in a vibrant community setting.\n\nBenefit from our top-notch amenities such as a chic clubhouse and relaxing cabana, complemented by convenient access to the airport and surrounding areas. At Rye Bunker Hill, you'll find the perfect balance of accessibility and modern living, making it easy to connect professionally and personally with the dynamic city of Dallas and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
      "featured_image_media": {
        "alt_text": "Spacious living room with a modern fireplace, comfortable seating, and large windows.",
        "public_id": "019fc91d-b450-76ce-9e56-a51332dabd97",
        "storage_key": "property/6767906449167585/019fc91d-b450-76ce-9e56-a51332dabd97.webp",
        "width": 2000,
        "height": 1125
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dallas County Apartments Near DFW Airport",
      "seo_description": "Discover Rye Bunker Hill's Dallas County apartments near Dallas Fort Worth International Airport, offering modern amenities and convenient travel access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701849870"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PCG8VBJ8"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Rise"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8b4748f9-5aae-47f4-924e-c456564de6fe/app.js?property=8b4748f9-5aae-47f4-924e-c456564de6fe&amp;propertyName=Rye Bunker Hill Apartments&amp;channelUuid=eddc12a5-7d9a-11ee-8764-42010aa8d42b\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39358347889"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8xvro456vjk"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Rye%20Bunker%20Hill/92710?source=community_link"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "214-617-2486"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImdmQkxNM0NwWjBsVlpCSTh1Qk41RUE9PSIsInZhbHVlIjoidy9EY3l4ek1CbzVhZ1hYc0tXK3Rwdz09IiwibWFjIjoiZWYwZGYxZmRjMmI5ZWM3ODQwNGMzZmFlOTQ4ZWZhZjZiZmQ5Y2U2NTdhMDUzMzg1YzhiN2U2Mzk5MjAwOThjNyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701849870",
  "custom_google_gtm_id": "GTM-PCG8VBJ8",
  "custom_rollout_phase": "Batch 1",
  "custom_vibesites_theme": "Rise",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/8b4748f9-5aae-47f4-924e-c456564de6fe/app.js?property=8b4748f9-5aae-47f4-924e-c456564de6fe&amp;propertyName=Rye Bunker Hill Apartments&amp;channelUuid=eddc12a5-7d9a-11ee-8764-42010aa8d42b\"></script>",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "39358347889",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8xvro456vjk",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Rye%20Bunker%20Hill/92710?source=community_link",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "214-617-2486",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImdmQkxNM0NwWjBsVlpCSTh1Qk41RUE9PSIsInZhbHVlIjoidy9EY3l4ek1CbzVhZ1hYc0tXK3Rwdz09IiwibWFjIjoiZWYwZGYxZmRjMmI5ZWM3ODQwNGMzZmFlOTQ4ZWZhZjZiZmQ5Y2U2NTdhMDUzMzg1YzhiN2U2Mzk5MjAwOThjNyJ9",
  "custom_audioeye_site_id": "f2bcc2d8-7360-4ab0-9389-d0c54e8f8667",
  "custom_audioeye_site_hash": "b9a9de06d9376667a87e32eb11732c6d"
};

export const generatedAt = '2026-11-03T23:03:27.695Z';
